<template>
     <body class="class-1">
        <div class="pos" id="pos">
            <!-- header -->
            <PosAppHeader />
            <!-- main box -->
            <div class="main_box">
                <div class="left_panel">
                   <div class="menue">
  <!-- Add this search bar section at the top -->
  <div class="search-bar-container mb-2">
    <input 
      type="text" 
      v-model="searchQuery" 
      placeholder="Search products..." 
      class="search-input"
      @input="handleSearch"
    />
    <button v-if="searchQuery" @click="clearSearch" class="clear-search-btn">
      ×
    </button>
  </div>

  <div class="menue_icons">
    <div class="first_row">
  <div 
    class="aa" 
    :class="{ active: activeTab === 'hotkeys' }" 
    @click="setActiveTab('hotkeys')"
  >
    <span>HOT KEYS</span>
  </div>
  <div 
    class="ab" 
    :class="{ active: activeTab === 'categories' }" 
    @click="setActiveTab('categories')"
  >
    <span>MENU</span>
  </div>
  <div 
      class="ac" 
      :class="{ active: activeTab === 'delivery' }" 
      @click="setActiveTab('delivery')"
    >
      <span>DELIVERY</span>
    </div>
</div>
  </div>
  
  <div class="line"></div>
  
  <div class="third_row d-flex flex-row flex-wrap">
  <!-- Hot Keys Content -->
  <template v-if="activeTab === 'hotkeys'">
    <div v-for="(item) in filteredHotkeys" :key="item.id" class="item" @click="addToOrder(item)"
    :style="item.image ? {background: `url(${item.image})`, backgroundSize: 'contain',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'} : {backgroundColor: '#E3655B'}">
      <div v-if="item.image" class="w-75 text1 d-flex flex-column justify-content-center">
        <div>{{ item.price }} AED</div>
      </div>
      <div v-if="item.image" class="w-75 text2 d-flex flex-column justify-content-center">
        <div class="">{{ item.languages[0].name }}</div>
      </div>
      <div v-else class="itemmenue d-flex flex-column justify-content-center">
        <span class="text3">{{ item.languages[0].name }}</span>
      </div>
    </div>
  </template>
  
  <!-- Categories Content -->
  <template v-else-if="activeTab === 'categories'">
    <!-- Show categories if none selected -->
    <template v-if="!selectedCategoryId">
      <div v-for="category in filteredCategories" :key="category.id" class="item" 
           @click="handleCategoryClick(category)"
           :style="category.image ? {background: `url(${category.image})`, backgroundSize: 'contain',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'} : {backgroundColor: '#E3655B'}">
        <div v-if="category.image" class="w-75 text1 d-flex flex-column justify-content-center">
          <!-- You might want to add something here for categories -->
        </div>
        <div v-if="category.image" class="w-75 text2 d-flex flex-column justify-content-center">
          <div class="">{{ getCategoryName(category) }}</div>
        </div>
        <div v-else class="itemmenue d-flex flex-column justify-content-center">
          <span class="text3">{{ getCategoryName(category) }}</span>
        </div>
      </div>
    </template>
    
    <!-- Show products when a category is selected -->
    <template v-else>
      <div v-for="product in filteredCategoryProducts" :key="product.id" class="item" 
           @click="addToOrder(product)"
           :style="product.image ? {background: `url(${product.image})`, backgroundSize: 'contain',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'} : {backgroundColor: '#E3655B'}">
        <div v-if="product.image" class="w-75 text1 d-flex flex-column justify-content-center">
          <div>{{ product.price }} AED</div>
        </div>
        <div v-if="product.image" class="w-75 text2 d-flex flex-column justify-content-center">
          <div class="">{{ product.languages[0].name }}</div>
        </div>
        <div v-else class="itemmenue d-flex flex-column justify-content-center">
          <span class="text3">{{ product.languages[0].name }}</span>
        </div>
      </div>
      
      <!-- Back button to return to categories -->
      <div class="item" @click="selectedCategoryId = null" style="background-color: #E3655B; cursor: pointer;">
        <div class="itemmenue d-flex flex-column justify-content-center">
          <span class="text3">Back to Categories</span>
        </div>
      </div>
    </template>
  </template>
  
  <!-- NEW: Delivery Menu Content -->
  <!-- Delivery Menu Content -->
<template v-else-if="activeTab === 'delivery'">
  <div v-for="(item) in filteredDeliveryItems" :key="item.id" class="item" @click="addToOrder(item)"
  :style="item.image ? {background: `url(${item.image})`, backgroundSize: 'contain',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'} : {backgroundColor: '#E3655B'}">
    <div v-if="item.image" class="w-75 text1 d-flex flex-column justify-content-center">
      <div>{{ item.price }} AED</div>
    </div>
    <div v-if="item.image" class="w-75 text2 d-flex flex-column justify-content-center">
      <div class="">{{ getProductName(item) }}</div>
    </div>
    <div v-else class="itemmenue d-flex flex-column justify-content-center">
      <span class="text3">{{ getProductName(item) }}</span>
    </div>
  </div>
</template>
</div>
</div>
                    <div class="v_line"></div>
                    <div class="cards-container d-flex flex-row flex-wrap">
            <!-- Dynamic cards based on API data -->
          
          </div>
                    
            
                    
                    <div class="content_table">
                      <div class="row" style="margin-left: 1rem;align-items: anchor-center;">
                          <div v-if="oredrType == 3" class="takeaway-cards p-2">
              <div class="d-flex flex-column align-items-center takeawayorder" style="border-radius: 5px;">
                <div class="symbol" style="width: 50px; height: 50px;">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                    bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                    bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                    eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                    MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                    dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                    dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                    IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                    ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                    cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                    RD0ieG1wLmlpZDozRkYxMkQ4MTA4QkYxMUVEODdGOTk2QThFMUE2MDczQiIgeG1wTU06RG9jdW1l
                                    bnRJRD0ieG1wLmRpZDozRkYxMkQ4MjA4QkYxMUVEODdGOTk2QThFMUE2MDczQiI+IDx4bXBNTTpE
                                    ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjNGRjEyRDdGMDhCRjExRUQ4N0Y5
                                    OTZBOEUxQTYwNzNCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjNGRjEyRDgwMDhCRjExRUQ4
                                    N0Y5OTZBOEUxQTYwNzNCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                    ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+UIuSOgAADrJJREFUeNrs3V1u6zYUhdHQ0AQy/0HeIfA+
                                    9AftRZA4sUgecq8FFGgfmkSSzfOJtpPWe38DALI8nAIAEAAAgAAAAAQAACAAAAABAAAIAACgquvV
                                    L/Dr1y9nEYA7+MU0n2v//Y/39/e1AQAABv/U89Tu+GJeAgDA8A88ZwIAAAIJAADc/QeeOwEAAHYA
                                    AAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAM5c8Bw978LnWSNc9fAQAGPoAAAEMfQACA
                                    oQ8gAMDgB9L5FAAY/oAdAMDgBwQAYPADAgAw+AEBABj8gAAADH5gFz4FAIY/YAcAMPgBAQAY/IAA
                                    AAx+QAAABj8gAMDgL6q5XHgeIQDgzEXLkAcEAIQMfkMfEABg8AMIADD4AQQAGPwAAgAMfiCcvwUA
                                    hj9gBwAMfoMfEABg8Bv8gAAAg9/gBwQAGPwGPyAAwOA3+IFd+BQAhr/hD9gBAIPf4AcEABj8Bj8g
                                    AMDgN/gBAQAGv8EPCAAw+AF24VMAGP6GP2AHAAx+gx8QAGDwG/yAAACDH0AAgMEPIADA4AfYhU8B
                                    YPgb/oAdADD4AQQAGPwAAgAMfgABAAY/gAAAgx9gFz4FgOEPYAfAwEGQsDWhByEBYFEHPloThAB8
                                    4bHxk9zwB9wcQFAAeGIDQFgAGP6A9QJucHkiA4AdAMMfAAQAACAA3P0DgAAw/AFAABj+ACAAAAAB
                                    4O4fmMuvAwY7AABA5QBw9w+4+wc7AACGP4xQ6VcBj7r7txjA2c9xz/d9rxcCwEIAhonnvOGPALAQ
                                    gGHiOW/wM9TjwAedhQAMfwx/NgkACwEYKJ7zhj8CADBQDH84PQDuWigsBmD44+4fOwCA4Y/hjwAA
                                    DH/guACwKIDhD9gBAAx/QAAAhj8gAADDHwQAgOHvGiIAAAx/EAAAhj8c6HIKAMOfRdfLyxB2AADD
                                    3/AHAQAY/oAAAAx/QAAAhj/1ry0CADAgDH8QAIDhb/ifwDUUADELFhj+BodrzDH8HgDA8Mdj1g4A
                                    YCE1/F1nBMAczQMbDH+2us6upwAADAXDAgRAxmIGni+Gv2uNACi4SHigg+HPuGvtugoAtQueH4aE
                                    a40AqPnA9+AHwx/Xlg9cxR5YIxYnEQAGhNCDoB0AwPA3/F1fNgkADzAw/HHnzwR+FTBg+Bv8rrEd
                                    AIsJ4Plq+Hv8JJw7OwCAxdvgd53tAFhYAM/R4kN/5kecm8fSuc+/q/gBekMLGP7u7HMeU9b8ic+9
                                    a4OD9YAAw99wzrjW4nIi7wEALM4Gv2sd6OGBCHgeGv6utQCo/ID0oAQDwfB3rQkLAA9O8JybPfgN
                                    fwSABykY/u76XWsEQJUHqwcsGAiGv2vND10HPXB9XBAMBMPftSYkAEbGgCcGiYOqOZ8GPxkensyA
                                    4e86YwcAyBxYhr/BjwAADAaD3/VFAGQ+sT1hSBlchr/BjwAA3Bka/q4rAgAwJAx/1xMBEPQE90Ti
                                    9AHWnDcDH+wAAIa/AU+gh1MAUVIGi98HAnYALI4Q9Pg2+CFsB8CTHkON7lggLwAAwx8QAMAfTt7+
                                    N/whNAB8/A9y7/r74ccHAgDAcAQBABj+wAt8DPAvtv/B4Ac7ABYEIPy53kKPGwEAYPiDAAAw/OEo
                                    O78HwMf/wOAfNfh7sXNhncIOAGD4u+sHAQDUHKqGPwiA0ouEJz/UeU5XGf53ri/txvMDAgDCnB6q
                                    Kwa/+EcAOAUQdZdt+APxAWAhAMPf+oIAsGiAoTvxZ5j5c3xny78P+v7WPgQAsPyOcuUgseUPAgAI
                                    2wkw/EEALF9ALAwwbyBX+ojfqvXFywAIAKBUuI4eKD7iBwIACNsJsOUPAqDUYmKRwC7Ax8+vXvBr
                                    zTovM9YXaw+lXE4B8MEgXPkauqD/+jyLCQQAhO4CzH7tvhUZ+O6oQQAAC3YGKkUQ8IJd3gPg9X/w
                                    WB517DPXFx8HRAAAIuAHxyviQQAAQQPR4IfAALD9DyLnpPXFywAIAEDcfnFcwh0EABAUAQY/CACL
                                    CYQ9zpufFwSA17jg+8Oobf7zJ6wv3geAAADclb55vR8EABAXAQY/CID/8fE/OPvOeuXPVmF98TIA
                                    AgCICwFhDov5Y0CQFwIr7xoNfhAAn7L9D+eEQLXnYaX1pb3ZwkcAAIvvyPugr8ucqHHOEQDArUO7
                                    G/QgAE5YzADPJeeEeBU/BeD1MCBpffFxQAQAACAAAICQAPDxPyBxffEyAHYAAAABAAAIgKfY/ges
                                    L7BRAHjtCkheX7wPADsAAIAAAAAODQAf/wOsL14GwA4AACAAAIDjAsD2P2B9sZZhBwCAQvGDAAAA
                                    BEAttswA6wtsFAC2qADry7josMZy/A4AACAAAICqAeDjf4D1Zfz39jIAdgAAAAEAAAJgMtv/gPUF
                                    7AAAMDBCvA8AAQAACAAAEACTeH0OsL7M/1m8DIAdAAAQAACAABjM9j9gfbHmYQcAgA0jCQEAAAiA
                                    OWyFAdYX2CgAbD0B1pf1cWItZtsdAABAAAAAVQPAx/8A60udn9HLANgBAAABAAAIgJvY/gesL2AH
                                    AIACseJ9AAIAABAAZxcvgPUFJgSALSbA+lI3WqzRAgAAEAAAgAD4IR/PAawv41gbsQMAwPKYQgAA
                                    AALgNba4AOsLbBQAtpSAUawv90eMcyoAAAABAAAIgCf5eA4wivVl3LF4GUAAAAACAAAQAF+wPQeM
                                    Yn0BOwAADIga7wMQAACAANizZAGsLzAhAGwdAaNYX+bFjXMtAAAAAQAACIA/+HgOMIr1xTEywOUU
                                    TF+smu/vseD8sMFj12NRAHDzYt8HLfTp3/+UO9WTzw9QSKX3AOy84PVJ/4/vX/f69wKPKc5cX6Bs
                                    AFioSNQHDX6sL1Vix7kXAAx8knTf31CyAAMreA8AGMiAHYBlvD5H9cFv+O+rOWaoGwDgrh9AAIDh
                                    DyAAwPAHuJU3AYLBD9gBAMMfQADM4d2qGP5YX8AOABj+IH4QAACAAAB3/wCv8ykADH+Y95iyLY8A
                                    AMOfwMdTFwJU4SUALNbjWOQ9ngQodgAgiMEP2AGAsLt/w9/jyS4AdgAgaPgb/IAdAAhj+AMCAMLu
                                    /g1/QACA4Q8gAOBkhj8gACDs7t/wBwQAuPMHEABw8t2/4Q8IAABAAIC7fwABAEcx/IHj+FXA592p
                                    7vb9HROAHQBw9w8gAMDdP4AAAHf/AAIARt79G/6AAAAABACczt0/IABgE978ByAAwN0/gADA3T8A
                                    AgAABADwD9v/gADA0Njk3Nn+BxAAIOQABIDh4ZwBIAA4ju1/gB+6nIJb72hP/l30Jx+b3QjADgAA
                                    IABYdydZaXu74t1/L3jNAAQAACAA7ALsuwtw8mv/AAIAABAA2AWofPfv9X8AAQAACAC7AKff/QMg
                                    AECUAAgAuwAJd/9+/S+AAAAABIBdgNPv/gEQACBMAASAXYCEu3+v/wMIAADgpy6nYOouwF13sH2D
                                    YwXADgCIEwABYPg4RgAEADzBGwABBIA7ZMcGgAAAgQIgAAwixwSAAAAABIA75g2PxRsAAQQAACAA
                                    4DneowAgAABAAAAAAgAAEACwlk8AAAgAAOAOl1OwvVff3e4OG8AOAIgkAAEAAAgA2JSXOQAEAMER
                                    IAQABIC70tBjEQIAAoC33DfICQFAAGB4BxMCgAAAIQAgAEAIAAgAiAsBAAEAAAgAmGXlGx3tAgAC
                                    AAAQAJCyCwAgAGBxBAgBgJtcTgGb7gbMen3e+wAAOwBgRwBAAIAQABAAfEN3TEIAQACAEAAQADw9
                                    6Cp+LSEAIAAAAAEAc3XHACAAAAABAAACAAAQAACAAAAABAAAIAAAAAEAAFR3OQXwqVd/nbBf5APY
                                    AeD4gdD9LI4FEAAAgADgRm2Tr+k8O6+AAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQANAdE4AAAAAE
                                    ADylFf1aAAIAABAAO+iOEQABAAAIAJ7SNv3aAAgAAEAAAAACAAAQAPAd3bEBCAAAQADAU9omXxNA
                                    AAAAAgAAEAAAgAAAAAEAAAgARumOFQABAAAIAJ7SDvkeoyTsPNhdAQQAACAA4A5t068NIAAAAAEA
                                    AAgAAEAAAIAAAAAEAAAgAAAAAQCV+FsLAAIAABAA7tgc83P8rQVAAAAAAoCMu1N3qQACAAAQAACA
                                    AAAABAAAIAAAAAEAY/k9CwACAAAQAPAcv2cBEAAAgAAAAAQAACAAAAABAJvqh34vAAFgQBlQAAgA
                                    znHXx+pmhE8vdsyAAMAugLv/wcdvZwUQALw0RPoGX7dtfo4Nf+Bol1MwRRswAPoNw9ZQev7cNOcW
                                    EAAk3LGKrLrn2Ov/wMu8BGDRdqwAAgAAEACwl+YYAQSAxdsxAiAADMiQY3N+AQQAIssxAQgAi3nS
                                    MTXnFkAAWNQdCwACwOAMOQbnF0AAWOBDf3bnF0AAWOhDf+bm5wUQABb93OFkxwJAABgAocOpasC4
                                    6wem8tcAaw/aXuzncY6dW0AAMHk49IXf2zl2bgEBgDtF5xhgd94DAAACAAAQAACAAADgX73I1wAB
                                    ALDR8BcBCACA0OEvAhAAAKHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIAIHwAiwAE
                                    AEDo4BUBCACA0IErAhAAAKGDVgQgAABCB6wIQAAAhA5WEYAAAAgdqCIAAQAQOkhFAAIAIHSAigAE
                                    AECxwdn+/kcEIAAAgob/R/8uAhAAAAHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIA
                                    4ABt0f8LAgBgw+EvAhAAAKHDXwQgAABCh78IQAAAhA5/EYAAAAgd/iIAAQAQOvxFAAIAIHT4iwAE
                                    AEDo8BcBCACA8AEsAhAAAKGDVwQgAABCB64I4HZXgZ/BH6wAKrEmYQcAABAAAIAAAAAEAAAgAAAA
                                    AQAACAAAQAAAAAIAABAAAIAAAAAqBIA/UgFwHmu7AAAABIBSBHD3z/auAQ8Yf0oTwOCn+sXu3bwG
                                    gDTeAwAAAgAAEAAAgAAAAAQAACAAAAABAACU9VuAAQBJZy7fCyQoAAAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 0.7209 1.5116)">
                                    </image>  
                </svg>
                </div>
                <div class="order-no">
                  <!-- <span class="light">Order #: </span> -->
                  <span class="order-id heavy">{{ orderId }}</span>
                </div>
              </div>
            </div>
                        <div v-if="oredrType == 1" class="cards-container d-flex flex-row flex-wrap">
                        <div class="delivery-cards p-2 ">
                            <div class="d-flex flex-column align-items-center deliverycon" style="border-radius: 5px;">
                                <div class="symbol" style="width: 50px; height: 50px;">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                            <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                    bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                    bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                    eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                    MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                    dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                    dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                    IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                    ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                    cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                    RD0ieG1wLmlpZDozNTUzNzgyNjA4QkYxMUVEODAyNEM0MzZCMTREQ0NGOCIgeG1wTU06RG9jdW1l
                                    bnRJRD0ieG1wLmRpZDozNTUzNzgyNzA4QkYxMUVEODAyNEM0MzZCMTREQ0NGOCI+IDx4bXBNTTpE
                                    ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjM1NTM3ODI0MDhCRjExRUQ4MDI0
                                    QzQzNkIxNERDQ0Y4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM1NTM3ODI1MDhCRjExRUQ4
                                    MDI0QzQzNkIxNERDQ0Y4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                    ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+CrVGUwAAFMJJREFUeNrs3e1ua6cWBdBg+f1f9TwClSqd
                                    9qhN4tjewPoYQ7r/blubDcwJdpIx5/wAAHq5GQIAUAAAAAUAAFAAAAAFAABQAAAABQAAUAAAAAUA
                                    AFAAAAAFAABQAAAABQAAeM/9169fRgHiWvXnOoehheYFwBBA+bD/6X9LKQAFACgY+s++FoUAFACg
                                    aOj/5HUqAqAAAMVD/9FrVwZAAQCKB79bAVAAgObBrwiAAgA0Dn5FABQAoHHwKwKQnN8ECMLfWIAb
                                    AEDYuQ0ANwCA8DdG4AYAEGpuA8ANAAh/jB0oACDAMIagAIDgwlhCWL4DADkCaxR6P/PDdwJAAQDh
                                    vzTwH/1758GxVQJAAQDhfygQx8H3rASAAgCtwz9KCJ4oA0oAKADQKvyjh97YOB5KABzgpwBgb/iP
                                    ZGG36/X66QBQAKB0+GelBIACAMK/+Kn/5PtQAkABgBKG96QEQES+BIjTv+B/5/0Ja3ADAMK/Sfjv
                                    eK+KBSgAIPyVAEABgH5B6L0DCgAEPVkKwDVj4BYAFAAQ/koAoABA3cAzJoACAIFPkoJu39i4BQAF
                                    AJxyjRGgAMD+E6RgOzNWbgFAAQAAFABw+ncLACgAkCDIjB2gAECS0z8xSoBnCgoAOMECKACw5qQo
                                    /N0CgAIAACgA4MSKMQUFAMJwRewZAwoAOKkaW0ABAAAFAMpxNdznFsCzBgUAwoUTgAIAACgA4PSP
                                    sQYFAC7jM2HPHFAAAAAFAIjIxwCgAIAwAlAAAAAFAOALvggICgBCAIBH7oYAWpWIEfh1KXCgAACb
                                    Co4vPUJTPgIAhQBQAICmJUARAAUAcBsAKACAEgAoAIASACgAAIACALgFABQAAEABAAAUALia32p3
                                    LR8DgAIAACgA4BYAQAEAJQBAAYAoJUARAPiCPwdM59uAufjfH4Ev8gFuAABFBVAAoPrpH0ABAJQx
                                    QAEAAAUAAFAAAHbyBUBQAAAABQAAUAAAPuEnAEABAJLx+T8oAACAAgAAKABAOR3+GBMoAACAAgBO
                                    sMYOUAAAnub6HxQAECAACgAQmet/UABAmBmvl7i9AQUAAFAAwC2AcQIUAHjAVbJnBgoAgNM/KACA
                                    gIs2Nk7/oACAUAFQAMAtgNM/oACAEmAsAAUAnC5zh7/nAwoAOPl6/4ACADFPmV1DcAZ/LoACAE7C
                                    wh8UAGBN4HQpAa79QQEAnPyd/kEBALcAlU/Hwh8UAOBBUM6C7wlQAMAtQJPQXF1mnP5BAQAloFHw
                                    C39QAKC8bB8J7Hitwh8UACh/C5DlNmBXURH+oABAyxLgC3WAAgANS4AiACgA0LgE/FkEOpUBxQcU
                                    AKBpGVACYKO7IYCnbwFOBdV88LoqBOn85P0AbgAgTAlwU+A2ABQAUAJQAkABgE4lQBFQAkABALcB
                                    KAGgAIASgBIACgAoASgBoABA3RKgCCgBoACA24BWxWfXr0wGFABwGxDsPSoBoAAARYvAo/e04z0r
                                    AaAAgCIQ9D0oAaAAAEmLwLuf7ysBEJA/BgRngzVqiI1F/z5hDQoAEKgMjI3/nRXvb3748UtQAEAZ
                                    CBP4SgAoAECAQhHpNSkBcJAvAQLVionvGYACAELW6wMUAKBLCXALAAoApNUpxJQAUAAANwGAAgB0
                                    CtSrX7NbAFAAgKaUAFAAgIa3AIACAE6tTUuAWwBQAAAlAPCrgEF4Rn8fgns/Y95gXSsAQLdg8x0D
                                    oV/hGb09jxUAwC2AUKFhGVAAwIb/TBBXKAFuAQR/xWf59JxWAMBmv+3EgfBn+TP98dr0UwBQf1OY
                                    C/+9O4NkXPz6hT+tn68CAII/U6AoATnmBAlKgAIATmjCxZyiYeFTAIBsQeMWwHvkAgoA0L0EeBa0
                                    nAMKALBq05mJXiu0KwEKAJCVWwDFhjfmgwIACKF6YSn8eUgBADKHkVsAeHEtKgCAE6mxpuH88KuA
                                    geyu+jsB/kbAc2NO8gKnAAA7NzbBkTM8PLdz5WpZIfARACCgDpy+EoWR8K/3DKYCAIDgz3kz8DYf
                                    AYBNpcqJuPt3AeamOUH+Of7hBgCc8E6cBF2zw/mCNt0A5G3wWnrv5797AxkfOYI7y+usHi4kmOcK
                                    QN6Nf1q0wn/z5t4pXDv+xIJ9pBkfAdTY+OeHv8cu/Pds7hm+bS/IUNgUgJYbvzJgDqwOxOHZeK24
                                    ASD+pqAMCH+nI0ABaNzYlQHhL2DxPPmHLwEKHwtf8PP98zKeRC5uL+8pbgB6nP7dDAh/p1rADQBu
                                    BoQ/0J0bANwMCH+3AOefH7gBwM2A8Bf+gAKAMiD8hT+wgI8AeDfgfEzw9bhUDv9sfyWw0/sFNwC4
                                    GXDqB1AAUAaEf7/TP6AAoAykD8NK4b/7vVzxlwz9UiAUAChaBiKfbJ38AQWAEn+XfUcZmIWet/AH
                                    FAD+FwpdysBs/pyrhP84OJaKDCgAykCCMuCZeh4R56fvAaAAoAwg/JO+N1AADIEygPBvdOr3MUC/
                                    Z44CIFgsduF/OAic/kEBQBkgWDiaB8+NlTKDAoAygPB3+gcFAGUAwR89/H0PABQAlAHh7+QPCgAo
                                    A/VDsdvfLlg5jsoNCgDKAMIfUABQBogV/rPJ+3z2NZqzKACA4G8U/oACQOKg6R7uwj/GGCs8KAAg
                                    1FuXMUEIydwMAZQ6kQp/pQXcAFAudEbA1yT4AQUABIrwBxQAECaCH1AAAOFf8llUGBfPtuF+oABg
                                    4xH8nZ+RXwhEW34KAIS/ggYNuQEAwS/4QQEAmoe/4IcmfAQAMYNf+Ctq4AYABIngBxQAap04ptd0
                                    lPD3kwAoAIDgB7rwHQAQ/oAbAEDwA24AAAAFAIBP+RIhCgAAoAAAZOD7EbTjS4AA+AjDDQBgkwcU
                                    AABAAQAAFABe5wtHACgAwDa+BwAoAG4BSDZfzBnlChQAmzrKIsYZXuf3AOTceObm/96u048N+Gdj
                                    5KQJuAFoaBZ9TcK/9xwCFAAAQAEAABSA5iJetbv+3894AQoAcKy4AQoAAKAAEJXrfwD+5vcA5OHK
                                    lv8WJ3OCqIcDEmSDGwCwcQANKQA4dQAoABQ+qUX8/B8FClAAgKTlElAAwOmV1vNSoUIBoHTY2uQA
                                    kvNjgPEJWx6Vu2mOAW4AAAA3AIQ9tfI+J3dAAbDBbwtboSP4AQUAEPqAAgAIfkAB4LjhNQl+gM/4
                                    KQABIJSMM+AGABD8gBsAuJbrf+EPuAFgcRgIW8EP4AYAQWVMARQAEP6AAkA5rv+FP4ACIByUEs8X
                                    QAFAaBlHoD0/BQD1w9/ti6IGCkCDjcdmL1DMAUABIITOgTSNM6AAgPAX+kCIPcaXAJ20I51gEf6A
                                    GwBNDs9T8FuHsIobABD+eD64AcDGY0M0jkCHg4YbgPonRvI/S+EPXE4BQDER/kDDvUYBgLiEv8IL
                                    q+bpUABqPExBUS88PFNg6T6jAOAEa9yAfocMPwUAwRam8M/7DD07UgT/77mqADgtAlA/9N0AdHzI
                                    BV+b0z/WjNfOm3wHAGIQ/sIPtu41CgAg/KHhQUMBcGp0oj0fHk7/wHYKAOD0Dw0PjAoAOP17ftAs
                                    /BWAoA9FcIDwh9U5owBAzgKI8Ie3+D0AMUJgvvDP2CTBnIaXc8INQL6ToFNjjTDxHIU/HM0UNwB5
                                    bgJGtckHQh/O7b8KgOAEoQ8N80MBgP0ho+gJfDh+eFQAAOEKjYJfAQCEPTQLfQUACixewQ/2CQUA
                                    EPx9ihvXzOP2z9TvAYBewSn8BQUoAAgIzxbhjwIAVA4T4S/8QQEAJ3+EP935EiA2TuGP+YsbAADh
                                    D24AAKd/wQ8KAAhTBD8oAIDCIvhBAQCEjvEHBQBA4IMCAGzT6fpf0IMCkHJztnkhXAEFoOGJTBlA
                                    +ANH+EVA58L/1f8fCH9AASgS/koAAApA0/AHAAVAcQAABUCIg7kHKAAAgAIAXMVPAIACAAAh+ahL
                                    ATAxAeyxvMJvAgRsrns/+hBguAEACFR85qb/DigATk/HTyLAnoDeVTCwzyoAAE7poAAAKBSgAITl
                                    WgqENvZZBcCGAYDwVwAAAAWAoNyEAE7/CoDQMzkBhL8CAADCXwHAYgHrAM9RATBJAesb464ApOFL
                                    byA4hBEKAIDwVwIczuLz54BrbzhArHU4hBMKgIYJCqlxZu3+Oo3113wEAAAKAIRp7kBvV53c7UcK
                                    QMiQczUFgAIAAA5JCgAWHcAVfAygAAhZAHslCoA2CYACAAAObgoAAMTgYwAFoEyLHMYJAAUAgGfK
                                    9Z//cwvgYPISfwuA7xabxQL7Qn3XP+s6HQUgcYsFeob9qv++fUkBIPjCBewbO15j1EJwxc2kvxCo
                                    ALBpU7HQEPr5X791rAAAUDT0f/LeFAEFwOJ+kcUD9oUq7/fUfuYLygqAhWyhgf3CrcDLr739gexu
                                    0QLYQ5oWAQXAQt12msYmieenCKAAWKRtNoVhLmFPUQQuPlB5NgqASYC5hLngRoAuBcDi3KdD0zaf
                                    MB/6FYH2XwS8W5jYmMB8ELj93BJNHIvTxmqzx/5irH9TJooXgEoL0wZjTmFdYtzDuJsc29+X1mpe
                                    YT5cfeqdicffnqgAtNmgM5aACl8EFP5kmAtj4T83Az8PJaBxAej4+7SH92x+0X4ujMP/rRnouSgB
                                    DQtA183ZhDe/6DcXoq35EWh8TuyJrffhe/PFqATY8DEXuoV+5DLw7PcC/EbAN9waLkYbU+1NDKKs
                                    sZF43YzDr19GFC0AHmzfMZnGlAZrK3PwR3o/1vBidw/zpROuiWnTxxx4df/IXAROFHm3j8kLgD/N
                                    a6KD8FcE7I3NCkDFb96u+uJJ9Ime4Qs3M9lcql62K7//7qG0swgoAQvcCi3Gzybnys+uRsExE1CP
                                    5xOYC2eKkI/2EhWAk1++GcknvokeZ9xs9sqlU3+cdWJvTFAAZtHJpwTY0OgZ/uZDnIJkbwxcAHZ/
                                    BjcKT/pZdIHP4GNloxf+5oOypAAEDayIE8xNgBMMtcJfkMVdS/bFYAVg1+dvo+GEN9mFP/vDHyVA
                                    AQgU/p0n/Cz2HqeNAOGvBFj759wTPACLEad/zIMa4yqwC90ACP++twBQ7fQv/BUsBSBAGFX48o0S
                                    4Fkh/DHW5QqAz9+UgCjfA1CIsOcYczbfAJgUSgBkP/0LIvu9AhAgeIaJrgTYhBD+1h8xC4DwVwKu
                                    fk9KDIIHktwAWIhKAGQ+/Qt/ZYwnC4ArOCUAhD9KQBH3Q4uw+wMfhQL7ivdyciwUJyGDfdENgIXo
                                    tATmM0qaArBqEXrAa8fBpgn2HQh3A2AR1iwBniuR57D5aV/khQJgESoBAEpAswIgQJQAcPqHpjcA
                                    FqES4BljTVH1+bWeIzcNXAmAQGvVXEV+FLsBQAkAwQGNCoBF2GvcPG9zDszNxAVgemhluQWgw/y0
                                    90CAGwDibWIz6evGM8McZWEB0MCVAMwxp39wA4ASgLkF5mv1AqCBKwEWao+5NIo+I/MO8+UJd3Mg
                                    1WRdEdjTQrDBHeY2itP7oAKgUSkBQgxlB3q4aeA2ukVzwIYMkKAA2PCVgKhFUDmtzfNF1hQoAFgE
                                    FirmGTQsAPOP/+FEBkDwArDqS2UKQd6TT7RnZg4BV+997feVXR8BTKWgbQlwPcvKOWZ+QfAC4JbA
                                    TYC2DqAAKATNSoBTGpBlz1MAFAILIuDp2zxAAECDAvCoEAiDniUAwL7WrAC4JchdApzWABQAtwSJ
                                    S4DGjueIfU4BcEtg47ZYAbIWgG6bcqdCUPX7AIocyiRcdAPQeTFV/9jAlwIB+LIAaNS1bwkilYBx
                                    8L8NwCcF4PfmrAjULARuAgDsYf+4PxEWNvrvxyLLn+edhRaQOWkNAhcXgJ+UAgvw+/GIWgiGZwfA
                                    /Y1/digCaQuBEgCgAHCoEJwuBUoAgAJAkFKwuxAoAQAKAAoBAArA3lPodyGoEKwtBW4BABSAEBSC
                                    50rBuGjMjTOAAqAQNCwESgCAApCqECgFj8diPDG2xhLopO13re5FH6AQe/2WQAkAUAAUAoUAwOlf
                                    Aaj1kJUCYwGgAGh+QhDA6V8BMBmUAgDBrwAsNT9i/+U8hQBA6CsAJpFCYLERzDRfPTvOFIDOPzbm
                                    YwOoEUKCJF/44wbALQEAPOumCW4pBH/+r1sBAnMOz90NAB8+NoCIfAyAAvBGqAmx60qBsQSqFy7c
                                    AGjgCgEAnQsAPy8ESgH8f428uyYcQvKc/j2nC9wKTozOpcBrAmB7AbD5A06n4AbAAmw2Tgog5iD2
                                    dwUAGy8IKew3nQrAsABTbVBX/JIiixGwryfkpwB4FOZT8JNsDl8RNH4iIO6hhcAFwAKs1aI9A4CC
                                    on8HwJXRuvEQ7GD/MY4KQOhTo8kDKLd4rs1uAHD6B6dX40eyAuAWwPuHCqdF68+hRQEQgiXet4UE
                                    9h/jxfICMEwq7xcK3ALgOSoAQjH1+7SQwN5jnNhWAIYJJvyhyOlRuO0dH/tWgRsAJcD7AiVA+Av/
                                    hgVg5YSbhRbPqvdiIYESYDw4VgCGyXfk9Qt/cAuZbf+ybxW8AVhdAqbFYxGBEuDkT7wCsCOUZqKF
                                    Y/GAEPS+HVyOuBefmKPRorGI4GfrYi5c1x3WnVtLNwApHnKkU/bO12IRwZn14UeU7VtuAA428UeT
                                    dhRZLBYRxA3JUfR9oQCkLAG7ysA8PJ7A+b2n0kcCc9PzoFkBOFUCvpvYI9jCsIAg796TuQj4yFIB
                                    KF8CIoe6BQQ19p5MRWBuHn8OuQVbiBg3qLyGIv/47+7XZu9SAEwI4wXt1lLXn1CydwVyD7wQfePU
                                    AoLda6ral5J/8t+1dykAFqPgB+vrI86XksfCf7f9i/C/CVAJsHig674zE71W+1dCtySTpvvEMQYg
                                    rCKf7IW/AmACed+geGMPy+CedCJNiwbYuBZ9FGkPcwOgmXtvIMwwXm4A3AhYMNAt1NwG2MfcADg1
                                    O/GDkMO4uAGINgGnhQK4DbCf0aMARC4DFgkoAsIfBeDwJPX3rYGr1/ts9n5RAEpN3mkhAG4D7HcK
                                    gGIA8M4+4ieUUAAA3AoIfhQAALcCQh8FAKBlGThdCAS+AgBAg0Ig8Pl3Mszp91gAQDc3QwAACgAA
                                    oAAAAAoAAKAAAAAKAACgAAAACgAAoAAAAAoAAKAAAAAKAACgAAAA7/lLgAEAAvBCG9O0l6EAAAAA
                                    SUVORK5CYII=" transform="matrix(1 0 0 1 -0.0233 0.3488)">
                                    </image>
                                        </svg>
                                </div>
                                <div class="order-no">  
                                  <!-- <span class="light">Order #: </span> -->
                                  <span class="order-id heavy">{{ orderId }}</span></div>
                            </div>
                        </div>
                    </div>
                      <div v-if="tableId>0" class="tables d-flex flex-row flex-wrap align-content-start" style="">
              <!-- Dynamic table cards based on API data -->
              <div
                   class="table-cards p-2 green" 
                   style="height: 80px;"
                  >
                  <div class="row">

                  </div>
                <div class="d-flex flex-column align-items-center">
                    <div class="symbol" style="width: 50px; height: 50px;">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;width:100%; height:100%" xml:space="preserve">
                                        <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                        bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                        bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                        eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                        MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                        dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                        dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                        IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                        ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                        cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                        RD0ieG1wLmlpZDo0Q0NDRTdENDA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiIgeG1wTU06RG9jdW1l
                                        bnRJRD0ieG1wLmRpZDo0Q0NDRTdENTA4QkYxMUVEQTkyRkMyNjdDNzJBREU4NiI+IDx4bXBNTTpE
                                        ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjRDQ0NFN0QyMDhCRjExRURBOTJG
                                        QzI2N0M3MkFERTg2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjRDQ0NFN0QzMDhCRjExRURB
                                        OTJGQzI2N0M3MkFERTg2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                        ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+yynrpwAADkVJREFUeNrs3Wty2zYUgNGAww1k/4v0EtDp
                                        tOlk3CiRLBK4j3N+t45F4vERku0x5/wGAPRyuAQAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAA
                                        IAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAAASASwAAAgAAEAAAgAAAAAQAACAAAAABAAAI
                                        AABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAABAAAIAAAAAEAAAgAAEAAAAACAAAQ
                                        AACAAAAABAAAIAAAAAEAAFzt/Pj4uOLrzBu+t+H2cKXv37+7CPzRRWsihN8jz2Av6NHXFwMAdN/0
                                        L90jz4AvSgwAYNN//d99aX88E7ywS14oABTb+N/aH49kL+7z9zSNOwDsQ6/v2UfSFxc9TgDw1B86
                                        To4iG6vTAADsNy/s5Uexp2oRAIA95onv+3CDAKDf3nIUfZEiAAB7ym9ew1F44xQBANhLHryWw40D
                                        gH57yNHghYoAAOwdn17X4UYCQL8942j0YkUAAPaKf1/j4V4DQD/nDbXzzh/pWfHnE/0RIQB2Pf1H
                                        2SPnGeiFff7/HdkDUMG48OtctjeewV7cr77m1SHgFACAFU//offGDJ8BsFkD0PWp/zZHkhd59b/h
                                        7QUA7toTUuyLmX4KwEkAAPaqQCcAWS+sUwAArtwLUj2oZvw9AE4CALA3NQwAEQCAPalpAFzF2wAA
                                        9oCWMgeAUwAA7EVOAACALgHgFAAAe5ATAABAAAAAAuABPwkAYO0XAAn5HAAA9h4nAACAAAAAbgkA
                                        76EDwFpv771/B4D30AGgl+EtAABoSAAAgAAAAAQAACAAAAABUIkfZQSw5guAhPwoIwD2HCcAAIAA
                                        AABuCQDvpwDAGpfsuT8CwHvoANDDuPIEAABIRAAAQEOnS8BFVnwO5K23qj4+PiK+Jlg+F0AAEH3D
                                        f/RvjoKvDd4Zo4KAl3kLgK8sPDPA9wDEmpcIAE+0FhjjAMxTc1wArOMIrNeCMpN8TTBvaymz1/gM
                                        ADZDqD+PPSBR+gQAmz9gTrMhAAywGouE+wjmNw1i7ucAcERkUAHmOk4AsCAA5jzFDAGAhQDMfZwA
                                        YAHgm7fBsAYgAMBmDSAAUP59Nn9hgbUAAYAJ3/TJfwgBrAlU5zcB/n8SDBO95ab/p3/XAon1z/on
                                        AIJvFG5wz83a68KTOtaBF3gLwOJx5cSwScL9G9Cd80xgOAEAT8aQYN7ZsAlzAmAw9nn698QPNU8E
                                        rONN1vHD0xye+sGcpN848RkA1WihARHgFKAhAYDNH8xRBAAAIACo4KqjPE8W0OsUwNsAAgBs/mDO
                                        IgA8MQNgbRcAyteTBGDuup4CAAAQAGzmyAuwhrAsAAyYOhwhgjlM0Rg7DBjEHJjD9ItBbwEAQEP+
                                        HHD94nv3CcATBHhqpCAnAAAgAAAAAQAACIBGKr3v7T08oPva4bNMjQLApgeAPcUJgMHrEgDWDAQA
                                        AAgAFD2AtUIAXMMHLgAg8J56KMB2Ze/eAtaHfvd22QkACQcDYE2gDwFgwgPWAgQAJj5gDaADfw2Q
                                        HwuAD26CjR8BgAVBEIANHwHQ02w+aSwYe8dexHs3jSkazqeyKn8GwGIDgL2kYQAAAAIAAFgRAN53
                                        AYCge+nvAsB76ACQ29hxAgAABCUAAEAAAAACAAAQAACAAOjAjzICWMMFQEJ+lBEAe4gTAABAAACA
                                        ALiF918AIOAe+qcA8B46ADgBAACSGAIAABAAL/I5BgBrtwAAAARABj7ICIC9wwnAlzhKArBmCwAD
                                        CgBrtQAwsACwRguAkHwOAAB7xk9O9/nLhSkqADz5OwFoeGOmQQdgHc66dz4TAFWedEfWmwTAsrW3
                                        zZ7nLQARkDW8wNoCb+gWAMOECrWAiQOwJnlgEQAioPnCJwaw6WPzFwCIAbDpw526/iIgG0z8hdJi
                                        ifGMPUEAuOEWTjB+sRcIADfeQgrGK/YAAUCrhRWMURAACtACC8Ym1v7IATATDAQhYKEFY7LHxj+M
                                        p+cDYDQaGORZcC26GIdY44OfABggePLC2MPaHui1CoDHF08IWIjBmLOel+U3AT5XUSY7gCf+UpwA
                                        KEhPZGCsWa+dAPBiUVoI4i3MJj42f0/6BAuAiouzgRdvsRQBVNv8jWfjzAkAJQLJExTY7El2AjAs
                                        3ly8wN01npwCkOmpzFhlCx8CZHcM3LX4iVWijyUfVmNrUAoAUg1YMOYh5wmApzJWLojGGxHHkM2f
                                        EGuWDwESMQJs3IhcCHYCcMUAtrizcqE03ogwdmz+hFs7fQYAAJwAQMlTADCWMVaCBIBjWVZOBuON
                                        XWPG5k+pEwADGk9PYOySfLztfAvAUxkAvB+OX4rNY+E3KALY+SRlrLFyrHj6Z9X4+fJY8yFAAIgZ
                                        AeOJ/+bLIvwiIH+4BQBu2OTvOgGwaVNiEoCxSkdR3gLw/iwAJAoAv7IVAJwAiAAA6BIAV7/fJQIA
                                        IMkJgAgAgIYBcAcRwN2hCcYoAiDowBcBANDsBEAEAECSALjr+GsKAYwBjFGIfQIwTC4ARGBsd/0t
                                        gHHjRZgLQgMAvrrpz4UPxuECYOUFFwIARH7aD7lf3fkhwLHwBnhrwEQDY5WV93hmHxt3nwCMhS94
                                        bogPLKjwaMxah6xDoa34McCx6UY5GTDpwNgl2l4SZlys+gzA2PiiZ6AwYd8Ecb/ZsV45mRRrYZ1J
                                        J5UbDthk4A2rfxOgAgaAhgEgAvhmzGHMQM8AMLkAoGkA/IgAIYDYxNiBZgFgkgEgLBsHgNMAxCXG
                                        EDQNAJMNYwljCWOpcQA4DcCCjTFFxfETbgwdLhgWajC26LePHS4gFmgwxui3bx0uKBZmMNbot0+d
                                        ySef362NxZid484aRNo16DQJMenAGkS/Neh0DzHpQAjQjwDAZg/3jllRgACw0aQzXVvYOgfMwdjr
                                        W2qHmwgA/faewz3EkwOYwzgBAJUM5g4CoMUEUcgA/Vyx9qeONCcAAOAEAFQyBOB0EwFgggDgAUcA
                                        AAACAJUM5TjdRAAk2NQAsBcIgGSFDABt9yRvAaCSwVzFCQCoZDBHEAB1J4hCBuDKPSFdvDkBQDiB
                                        OYoTALidI04wNxAAWyaIQgbgjr0hVcQ5AQAAJwCgkmEDp5sIABMEAA84AgAAEACoZCjH6SYCIMGm
                                        BYC9QgAkK2QAsGc1PAFAJYO5CAIAlQzmAAKg+gRRyACs3DPCx50TAABwAgAqGRZxuokAMEEA8IAj
                                        AAAAAYBKhnKcbiIATBAAPOAIAABAAKCSoRynmwiABJsSAB5wBECyQgYAe9oDpwsOYH2jH58BwKIG
                                        xjgCwAQBgA572+meQLlFYSZ6rT6sCwIA/tskRtHXxfPXxRiAZgFggmDB5/O1c0qABxwnAGDTFwPA
                                        FfwUADZR37dr7PumIScAYHHPer2dBkCREwCLKDZ/XHuM24YBACYy7gEIACzsvj+MFageACYINhzc
                                        E4xXJwBg4uLegADAgu77wZiBcgFggmBjwb3COF2syu8B8PPABjhUZX2zvpU9AcDCFX2SCRmL867v
                                        weZP2QAwQQDwgLOBXwUM+yfocG1v+/oeEEAAsLGS313oqy3kNqVfX4dKb7U43SS87J8BMEHI9IQ6
                                        jNnl18fnN7AHBQwAExMLBa4VHjScAGBB9/pxzbx+BIAJwt5KnsZpmTk+i49V7EWpAsAEwcKAawgb
                                        90RvAWAhB3OFhgQAKtki7lr2HKMIgJQTxOKKRRz3lEqRunyMOgEAACcAoJKDvE7yXVOnmwgAEwQA
                                        kRr7AccJAAA05I8BsaOSI/9xoBnka3DPvY08bpxuslS2EwATBAB7VLIA8FQEAEH2Sp8BQCVj3Pne
                                        aEgAoJItxCR5YoOMAeADMgB0kObHAZ0AAIATAEhVyR2/N4w3aBUAJggAgtMJAJjAuJcgALAwgzkA
                                        IQNgmCBYnHEPMfbijFsnAGSdJCPBJKbH5j+MLZwAXD/YTRA8ReKe0WkcLhu7R+CLYQKbJJHGxjAm
                                        04ylYQyTdH1bOi7OTRdjmhw8uOcz+Lh45vuk5xN/ljGMfe+ff3BO6xgAdONDgAAgAAAAAQAACAAA
                                        QAAAAAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAABAAAAAAgAAEAAA
                                        gAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAACAAAAABAAAIAAA
                                        AAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAAAQAACAAAQAAA
                                        AAIAABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAIAAAAAEAAAgAAAAAQAAAgAAEAAAgAAA
                                        AAQAACAAAAABAAAIAABAAAAAAgAAEAAAgAAAAAQAACAAAAABAAAIAABAAAAAAgAAEAAAIAAAAAEA
                                        AAgAAEAAAAACAAAQAACAAAAABAAAIAAAAAEAAAgAAEAAAAACAAAQAACAAAAABAAAIAAAQAAAAAIA
                                        ABAAAIAAAAAEAAAgAAAAAQAACAAAQAAAAAIAABAAAMDl/hJgAMM46gkHnacUAAAAAElFTkSuQmCC" transform="matrix(1 0 0 1 0.4651 0.3953)">
                                        </image>
                                        </svg>
                                    </div>
                  <div class="table-number textcenter">
                        <span>{{ table_name ? table_name : '' }}</span>
                  </div>
                </div>
              </div>
            </div>
                      <div class="barcode-search-container mb-2">
                      <input 
                        type="text" 
                        v-model="barcodeQuery" 
                        ref="barcodeInput" 
                        placeholder="Scan or enter barcode..."
                        class="barcode-input"
                        @click="openNumericKeypad('barcode')"
                        @input="searchByBarcode" 
                      />
                      <button 
                        class="clear-barcode-btn" 
                        @click="clearBarcodeSearch"
                        v-if="barcodeQuery"
                      >
                        ×
                      </button>
                    </div>
                      </div>
                      <div 
                      class="barcode-results" 
                      v-if="showBarcodeResults && barcodeProducts.length > 0"
                    >
                      <div 
                        v-for="product in barcodeProducts" 
                        :key="product.id" 
                        class="barcode-result-item"
                        @click="addBarcodeProduct(product)"
                      >
                        {{ product.languages[0].name }} - {{ product.barcode }} ({{ product.price }} AED)
                      </div>
                    </div>  
                      <div class="center-panel d-flex flex-column justify-content-between ">
                            <div class="">
                                <div class="table_header d-flex flex-row ">
                                    <div class="itemcell cell" style="font-size: 16px;font-weight: 700;">ITEM</div>
                                    <div class="ratecell cell" style="font-size: 16px;font-weight: 700;">RATE</div>
                                    <div class="qtycell cell" style="font-size: 16px;font-weight: 700;">QTY</div>
                                    <div class="totalcell cell" style="font-size: 16px;font-weight: 700;">TOTAL</div>
                                </div>
                                <!-- loop backend data to get table content rows-->
                                <div v-for="(item, index) in orderItems" :key="index" class="table_row d-flex flex-row">
       <div class="itemcell cell">
  {{ item.name }}
  <!-- Show note if it exists -->
  <div v-if="item.note" class="note-text" style="color: red; font-size: 12px;">
    {{ item.note }}
  </div>
  <!-- Show customizations if they exist -->
  <!-- <div v-if="item.customizations && item.customizations.length > 0" class="customizations-text" style="font-size: 12px; color: #555;">
    <div v-for="(custom, index) in item.customizations" :key="index">
      + {{ custom.name }} ({{ custom.price }} AED)
    </div>
  </div> -->
</div>
        <div class="ratecell cell">{{ formatPrice(item.price) }}</div>
        <div class="qtycell cell d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center">
          <span class="plus" @click="increaseQuantity(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512" fill="#88DD86"><!--! Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 368C269.3 368 280 357.3 280 344V280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H280V168C280 154.7 269.3 144 256 144C242.7 144 232 154.7 232 168V232H168C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H232V344C232 357.3 242.7 368 256 368z"/></svg>
          </span>
          <span class="qtycontent">{{ item.quantity }}</span>
          <span class="minus" @click="decreaseQuantity(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512" fill="#E91C0C"><!--! Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM168 232C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H168z"/></svg>
          </span>
        </div>
        <div class="totalcell cell">
          <span class="total">{{ (item.price * item.quantity).toFixed(2) }}</span>
          <span 
              class="customize" 
              id="customize1" 
              @click="customizeItem(item)" 
              data-toggle="modal" 
              data-target="#customizedish"
            >
              <svg 
                style="background-color:#E3655B; padding:2.5px; border-radius:5px;" 
                width="23.05px" 
                viewBox="0 0 24 24" 
                fill="white"
              >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"/>
              </svg>  
            </span>
        </div>
      </div>
      <div class="toast" v-if="showToast">
  {{ toastMessage }}
</div>
                            </div>
                            <!-- this div to streatch table borders-->

                            <div class="grow d-flex flex-row ">
                                <div class="itemcell" ><span style="visibility: hidden;">1</span></div>
                                <div class="ratecell"><span style="visibility: hidden;">1</span> </div>
                                <div class="qtycell"><span style="visibility: hidden;">1</span></div>
                                <div class="totalcell"><span style="visibility: hidden;">1</span></div>
                            </div>
                            
                            <div class="table_footer d-flex flex-row justify-content-between">
                                <div class="d-flex flex-column p-2 justify-content-center">
                            <div class="d-flex flex-column flex-lg-row">
                            <div> NET TOTAL:</div>
                            <div>{{ netTotal.toFixed(2) }}<span class="currency"> AED</span></div>
                            </div>
                            <div class="d-flex flex-column flex-lg-row">
                              <div> TAX:</div>
                            <div>({{ tax.toFixed(2) }}<span class="currency"> AED</span>)</div>
                              <!-- <div>{{ totalTaxPercentage() }}% ({{ tax.toFixed(2) }}<span class="currency"> AED</span>)</div> -->
                            </div>

                        </div>
                                <div style="position: relative;">
                                    <div class="leftborder"></div>
                                </div>
                                
                                <div class="d-flex flex-column flex-lg-row p-2 align-items-center">
      <div class="d-flex flex-column mr-0 mr-lg-2">
    <div style="align-self: center;" class="">DISCOUNT:</div>
    <div class="d-flex flex-row">
            <div class="d-flex">
        <input 
        style="color: #000;"
            type="text" 
            id="first" 
            v-model="firstvalue"
            @input="validateNumber('firstvalue')"
            @click="openNumericKeypad('firstvalue')"
            :disabled="!!secondvalue"
            readonly
            placeholder="Amount"
        >
        <label class="white" for="first">#</label>
    </div>
        <div class="d-flex">
        <input 
            type="text" 
            style="color: #000;"
            id="second" 
            v-model="secondvalue"
            @input="validateNumber('secondvalue')"
            @click="openNumericKeypad('secondvalue')"
            :disabled="!!firstvalue"
            readonly
            placeholder="percentage"
        >
        <label class="white" for="second">%</label>
    </div>
    </div>
</div>
                                    
                                </div>
                                <div style="position: relative;">
                                    <div class="leftborder"></div>
                                </div>
                                
                                <div class="d-flex flex-column p-2 justify-content-center">
    <div> Grand TOTAL: </div>
    <div>{{ grandTotal.toFixed(2) }}<span class="currency"> AED</span></div>
  </div>

                            </div>
                            
                        </div>

                        <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#customizedish">
                                Launch Popup
                            </button> -->
   <div class="modal fade" id="customizedish" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">CUSTOMIZE: {{ selectedItem?.name }}</h5>
      </div>
      <div class="modal-body1 d-flex flex-column justify-content-between">
        <!-- Customizations Section -->
        <div v-if= "availableCustomizations" class="customizations-section mb-3">
          <h6>Available Customizations:</h6>
          <div class="customization-options">
  <div v-for="customization in availableCustomizations" :key="customization.id" class="customization-option">
    <div class="form-check">
      <input 
  class="form-check-input" 
  type="checkbox" 
  :id="'customize-' + customization.id"
  v-model="customization.isSelected"
  @change="updateCustomizationPrice(customization, $event)"
>
      <label class="form-check-label" :for="'customize-' + customization.id">
        {{ customization.languages[0]?.name }} (+{{ customization.price }})
      </label>
    </div>
  </div>
</div>
        </div>
        
        <!-- Notes Section -->
        <!-- Notes Section -->
<div class="notes-section mb-3">
  <label for="item-notes" class="form-label">Special Instructions:</label>
  <div class="input-group">
  <textarea 
    id="item-notes" 
    class="form-control" 
    rows="3" 
    v-model="selectedItem.note"
    placeholder="Add any special instructions here..."
    @click="openNumericKeypad('notes')"
    readonly
  ></textarea>
  <button 
    class="btn btn-outline-secondary" 
    type="button"
    @click="openNumericKeypad('notes')"
  >
    <i class="fas fa-keyboard"></i>
  </button>
</div>
</div>
        
        <div class="buttonsrow">
          <div class="d-flex flex-row justify-content-between">
            <div class="clear" @click="clearCustomizations"><span>CLEAR</span></div>
            <div class="ml-auto d-flex flex-row">
              <div class="cancle" data-dismiss="modal"><span>CANCEL</span></div>
              <div class="done" @click="saveCustomizations" data-dismiss="modal"><span>DONE</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
                        <!-- Add this anywhere in your template -->
<!-- Order Notes Modal -->
<div class="modal fade" id="orderNotesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ORDER NOTES</h5>
      </div>
      <div class="modal-body1 d-flex flex-column justify-content-between">
        <div class="notes-section mb-3">
          <label for="order-notes" class="form-label">Special Instructions for the whole order:</label>
          <div class="input-group">
            <textarea 
              id="order-notes" 
              class="form-control" 
              rows="3" 
              v-model="orderNote"
              placeholder="Add any special instructions for the entire order..."
              @click="openNumericKeypad('orderNotes')"
              readonly
            ></textarea>
            <button 
              class="btn btn-outline-secondary" 
              type="button"
              @click="openNumericKeypad('orderNotes')"
              style="border: 1px solid #dee2e6; border-left: none;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-keyboard" viewBox="0 0 16 16">
                <path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/>
                <path d="M3 8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 3 9zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 5 9zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 7 9zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM3 10a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </button>
          </div>
        </div>
        
        <div class="buttonsrow">
          <div class="d-flex flex-row justify-content-between">
            <div class="clear" @click="clearOrderNote"><span>CLEAR</span></div>
            <div class="ml-auto d-flex flex-row">
              <div class="cancle" data-dismiss="modal"><span>CANCEL</span></div>
              <div class="done" @click="saveOrderNote" data-dismiss="modal"><span>DONE</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
                        <!-- <div class="line2">
                        </div>
                        <div class="line3"></div>
                        <div class="line1"></div> -->
                    </div>
                </div>
         <div class="right_panel">
  <!-- Split Button - Only show for active dine-in orders with items -->
  <div 
    v-if="oredrType == 2 && orderItems.length > 0 && !isOrderCompleted" 
    style="background-color: #52414C;" 
    class="right right-split d-flex flex-column justify-content-center align-items-center" 
    @click="splitTable"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    </svg>
    <div class="txt">Split</div>
  </div>

  <!-- Combine Table button - Only show for active dine-in orders with items -->
  <div 
    v-if="oredrType == 2 && orderItems.length > 0 && !isOrderCompleted" 
    class="right right-combine d-flex flex-column justify-content-center align-items-center" 
    @click="combineTables"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect>
      <line x1="7" y1="2" x2="7" y2="22"></line>
      <line x1="17" y1="2" x2="17" y2="22"></line>
    </svg>
    <div class="txt">Combine</div>
  </div>
<div 
  v-if="!oredrType" 
  class="right right1 d-flex flex-column justify-content-center align-items-center" 
  @click="showCustomerModal"
>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="66" height="39" viewBox="0 0 66 39" fill="none">
      <rect width="66" height="39" fill="url(#pattern0)"/>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_2_63" transform="translate(0 -0.358974) scale(0.00195312 0.00330529)"/>
        </pattern>
        <image id="image0_2_63" width="512" height="512" xlink:href="data:image/png;base64,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"/>
      </defs>
    </svg>
    <div class="txt">Dine in</div>
  </div>

  <RestaurantCustomerModal 
    ref="customerModal"
    v-if="showModal"
    @submit="handleCustomerSubmit"
    @close="closeModal"
  />
  
  <!-- Takeaway button - Only show when no order type is selected or when taking a new order -->
  <div 
    v-if="!oredrType" 
    class="right right2 d-flex flex-column justify-content-center align-items-center" 
    @click="takeawayOrder"
  >
    <img class="" src="../assets/Takeaway 1.png" alt="Takeaway">
    <div class="txt">Takeaway</div>
  </div>
  
  <!-- Delivery/Drivers button - Show for new orders or active delivery orders -->
  <div 
    v-if="oredrType == 1 || !oredrType" 
    class="right right3 d-flex flex-column justify-content-center align-items-center" 
    @click="openPopup"
  >
    <img 
      :src="oredrType == 1 ? require('../assets/driver.png') : require('../assets/Delivery 1.png')" 
      :alt="oredrType == 1? 'Drivers' : 'Delivery'"
      :style="oredrType == 1? 'width: 50px;' : ''"
      :class ="oredrType == 1? 'driver-img' : ''"
    >
    <div class="txt">{{ oredrType ? 'Drivers' : 'Delivery' }}</div>
  </div>
  
  <!-- Save button - Show when there are items in the order -->
  <div 
    v-if="showmodal || oredrType" 
    class="right right8 d-flex flex-column justify-content-center align-items-center" 
    @click="saveOrder"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <path d="M43.5714 1H8.42857C4.30714 1 1 4.30714 1 8.42857V43.5714C1 47.6929 4.30714 51 8.42857 51H43.5714C47.6929 51 51 47.6929 51 43.5714V8.42857C51 4.30714 47.6929 1 43.5714 1ZM38.7143 21.2857L21.2857 38.7143C20.5 39.5 19.2143 39.5 18.4286 38.7143L13.2857 33.5714C12.5 32.7857 12.5 31.5 13.2857 30.7143L15.3571 28.6429C16.1429 27.8571 17.4286 27.8571 18.2143 28.6429L19.8571 30.2857L33.7857 16.3571C34.5714 15.5714 35.8571 15.5714 36.6429 16.3571L38.7143 18.4286C39.5 19.2143 39.5 20.5 38.7143 21.2857Z" stroke="white" stroke-width="2"/>
    </svg>
    <div class="txt">SAVE</div>
  </div>
  
  <!-- Print button - Show when there's an active order with items -->
  <div 
    v-if="oredrType && orderItems.length > 0" 
    class="right right9 d-flex flex-column justify-content-center align-items-center" 
    @click="printOrder"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <path d="M43.5714 13H8.42857C5.98571 13 4 14.9857 4 17.4286V38.1429H8.42857V43.5714H43.5714V38.1429H48V17.4286C48 14.9857 46.0143 13 43.5714 13ZM39.1429 38.1429H12.8571V30.7143H39.1429V38.1429ZM39.1429 26H12.8571V21.5714H39.1429V26ZM43.5714 21.5714H48V17.4286C48 16.0857 46.9143 15 45.5714 15H43.5714V21.5714Z" stroke="white" stroke-width="2"/>
    </svg>
    <div class="txt">PRINT</div>
  </div>
  
  <!-- Cancel button - Show when there's an active order with items -->
  <div 
    v-if="oredrType && orderItems.length > 0" 
    class="right right10 d-flex flex-column justify-content-center align-items-center" 
    @click="showCancelDialog"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <path d="M26 4C14.9543 4 6 12.9543 6 24C6 35.0457 14.9543 44 26 44C37.0457 44 46 35.0457 46 24C46 12.9543 37.0457 4 26 4ZM35.4286 30.5714L30.5714 35.4286L26 30.8571L21.4286 35.4286L16.5714 30.5714L21.1429 26L16.5714 21.4286L21.4286 16.5714L26 21.1429L30.5714 16.5714L35.4286 21.4286L31.1429 26L35.4286 30.5714Z" stroke="white" stroke-width="2"/>
    </svg>
    <div class="txt">CANCEL</div>
  </div>

  <!-- Cancel Popup Modal -->
  <div v-if="showCancelPopup" class="modal-overlay">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Cancel Order</h5>
          <button @click="showCancelPopup = false" class="close-btn">&times;</button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <textarea 
              v-model="cancelReason" 
              placeholder="Please enter the reason for cancellation..."
              class="reason-input form-control"
              @click="openNumericKeypad('cancelReason')"
              readonly
            ></textarea>
            <button 
              class="btn btn-outline-secondary" 
              type="button"
              @click="openNumericKeypad('cancelReason')"
            >
              <i class="fas fa-keyboard"></i>
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="showCancelPopup = false" class="btn btn-secondary">Cancel</button>
          <button @click="confirmCancel" class="btn btn-danger">Confirm Cancellation</button>
        </div>
      </div>
    </div>
  </div>

  <TakeawayCustomerPopup 
    ref="takeawayCustomerModal"
    @submit="handleTakeawayCustomerSubmit"
  />
  
  <DeliveryPopup 
    v-if="showPopup" 
    @close="closePopup"
    @submit="handleDeliverySubmit"
  />
  
  <PaymentPopup 
    v-if="showpayPopup" 
    @close="closePayPopup"
    @payment-success="handlePaymentSuccess"
    @payment-error="handlePaymentError"
    :grandTotal="grandTotal"
    :orderId="orderId"
  />
  
  <DriversPopup 
    v-if="showdriversPopup" 
    @close="closePopup"
    @submit="handleAssignDriver"
  />
  
  <!-- Pay button - Only show when there's an active order with items -->
  <div 
    v-if="oredrType && orderItems.length > 0" 
    class="right right7 d-flex flex-column justify-content-center align-items-center" 
    @click="openPayPopup"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="dollarsign" width="27" height="48" viewBox="0 0 320 512"><!--! Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M160 0C177.7 0 192 14.33 192 32V67.68C193.6 67.89 195.1 68.12 196.7 68.35C207.3 69.93 238.9 75.02 251.9 78.31C268.1 82.65 279.4 100.1 275 117.2C270.7 134.3 253.3 144.7 236.1 140.4C226.8 137.1 198.5 133.3 187.3 131.7C155.2 126.9 127.7 129.3 108.8 136.5C90.52 143.5 82.93 153.4 80.92 164.5C78.98 175.2 80.45 181.3 82.21 185.1C84.1 189.1 87.79 193.6 95.14 198.5C111.4 209.2 136.2 216.4 168.4 225.1L171.2 225.9C199.6 233.6 234.4 243.1 260.2 260.2C274.3 269.6 287.6 282.3 295.8 299.9C304.1 317.7 305.9 337.7 302.1 358.1C295.1 397 268.1 422.4 236.4 435.6C222.8 441.2 207.8 444.8 192 446.6V480C192 497.7 177.7 512 160 512C142.3 512 128 497.7 128 480V445.1C127.6 445.1 127.1 444.1 126.7 444.9L126.5 444.9C102.2 441.1 62.07 430.6 35 418.6C18.85 411.4 11.58 392.5 18.76 376.3C25.94 360.2 44.85 352.9 60.1 360.1C81.9 369.4 116.3 378.5 136.2 381.6C168.2 386.4 194.5 383.6 212.3 376.4C229.2 369.5 236.9 359.5 239.1 347.5C241 336.8 239.6 330.7 237.8 326.9C235.9 322.9 232.2 318.4 224.9 313.5C208.6 302.8 183.8 295.6 151.6 286.9L148.8 286.1C120.4 278.4 85.58 268.9 59.76 251.8C45.65 242.4 32.43 229.7 24.22 212.1C15.89 194.3 14.08 174.3 17.95 153C25.03 114.1 53.05 89.29 85.96 76.73C98.98 71.76 113.1 68.49 128 66.73V32C128 14.33 142.3 0 160 0V0z"/></svg>
    <div class="txt">Pay</div>
  </div>
  
  <!-- Notes button - Show when there's an active order -->
  <div 
    class="right right4 d-flex flex-column justify-content-center align-items-center" 
    @click="openNotesModal"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <path d="M35.8214 33.1429H51V3.67857C51 2.1942 49.8058 1 48.3214 1H3.67857C2.1942 1 1 2.1942 1 3.67857V48.3214C1 49.8058 2.1942 51 3.67857 51H33.1429V35.8214C33.1429 34.3482 34.3482 33.1429 35.8214 33.1429ZM50.2188 39.2813L39.2813 50.2188C38.779 50.721 38.0982 51 37.3839 51H36.7143V36.7143H51V37.3951C51 38.0982 50.721 38.779 50.2188 39.2813Z" stroke="white" stroke-width="2"/>
    </svg>
    <div class="txt">NOTES</div>
  </div>
  
  <!-- Logout button - Always visible -->
  <div 
    class="right right5 d-flex flex-column justify-content-center align-items-center" 
    @click="handleLogout"
    style="cursor: pointer;"
  >
    <img class="" src="../assets/power-off 1.png" alt="log out">
    <div class="txt txt1">Logout</div>
  </div>
  
  <!-- End Session button - Always visible -->
  <div class="right right6 d-flex flex-column justify-content-center align-items-center">
    <img class="" src="../assets/ClosePOS 1.png" alt="END SESSION">
    <div class="txt txt1">END SESSION</div>
  </div>
</div>
                
            </div>
                <NumericKeypad ref="numericKeypad" @input="handleKeypadInput" @close="closeKeypad" />
                 <Keyboard 
    ref="keyboard"
    @input="handleKeyboardInput"
    @submit="handleKeyboardSubmit"
  />
                <!-- <Keyboard 
    ref="keyboard"
    @input="handleKeyboardInput"
    @submit="handleKeyboardSubmit"
  /> -->

        </div>
    </body>
</template>


<script>
import RestaurantCustomerModal from './table_details_component.vue';
import DeliveryPopup from "./delivery_process_component.vue";
import PaymentPopup from "./payment_popup.vue";
import DriversPopup from "./drivers_popup_component.vue";
import PosAppHeader from "./pos_header_component.vue";
import NumericKeypad from './NumericKeypad.vue';
import Keyboard from './keypad_popup_component.vue';
import TakeawayCustomerPopup from './TakeawayCustomerPopup.vue';
  import { BASE_API_URL } from '@/config'; 
  import $ from 'jquery';
  import axios from 'axios';
export default {
  components: { 
    Keyboard,
   TakeawayCustomerPopup,
    NumericKeypad,
    DeliveryPopup,
    PaymentPopup,
    DriversPopup,
    PosAppHeader,
    RestaurantCustomerModal
  },
    data() {
  return {
    formData: {
      tableNumber: '',
      customerCount: 1,
      reserved_at: new Date().toISOString().slice(0, 16) 
    },
    barcodeQuery: '',
     showTakeawayCustomerModal: false,
    ordernet: 0, 
    selectedFloorId: null,
    selectedOrderTotal: 0,
    orderCompleted: false, 
    barcodeProducts: [], 
    showCancelPopup: false,
    cancelReason: '',
    deliveryItems: [],
     barcodeSegments: null,
    showBarcodeResults: false,
    selectedCustomizations: [],
    availableCustomizations: [], 
    originalPrice: 0,
    scantotal: 0,
    tableData: null,
    addressDetails: {},
    hotkeys: [],
    categories: [],
    activeTab: 'hotkeys', 
    searchQuery: '',
    loading: true,
    secondvalue: '',
    firstvalue: '',
    orderNote: '',
    showNotesModal: false,
    error: null,
    showLinks: false,
    showPopup: false,
    showpayPopup: false,
    showdriversPopup: false,
    showModal: false,
    shouldResetModal: false,
    orderItems: [], 
    categoryProducts: [],
    selectedCategoryId: null,
     showToast: false,
    toastMessage: '',
    orderId: '',
    tableId: '',
    table_name: '',
    oredrType: '',
    selectedItem: {
      id: null,
      name: '',
      price: 0,
      quantity: 1,
      customizations: [],
      note: ''
    },
  };
},
watch: {
    secondValue() {
      this.updateGrandTotal();
    }
  },
methods: {
handleGlobalKeyDown(e) {
  // Don't process if user is typing in any input, textarea, or contenteditable
  const activeElement = document.activeElement;
  const isTypingInForm = activeElement.tagName === 'INPUT' || 
                         activeElement.tagName === 'TEXTAREA' || 
                         activeElement.isContentEditable;
  
  if (isTypingInForm) {
    return;
  }
  
  if (e.ctrlKey || e.altKey || e.metaKey || 
      [16, 17, 18, 20, 91, 93].includes(e.keyCode)) {
    return;
  }
  
  // Only process barcode input if barcode input is specifically focused
  if (document.activeElement.tagName === 'INPUT' && 
      document.activeElement !== this.$refs.barcodeInput) {
    return;
  }
  
  if (![13, 9, 27].includes(e.keyCode)) {
    e.preventDefault();
  }
  
  this.processBarcodeInput(e.key);
},
async fetchBarcodeSegments() {
  try {
    const token = localStorage.getItem('authToken');
    const branchId = localStorage.getItem('branchId');
    
    const response = await axios.get(
      `${BASE_API_URL}/api/barcode-segs?branchId=${branchId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    if (response.data.data && response.data.data.length > 0) {
      return response.data.data[0]; // Assuming one config per branch
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch barcode segments:', error);
    return null;
  }
},
async fetchDeliveryMenu() {
  if (!this.$hasPermission('view delivery menu')) {
    this.$toast.error('Not Permitted to view delivery menu');
    return;
  }
  
  const url = `${BASE_API_URL}/api/products/delivery_menu`;
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };

  try {
    this.$root.isLoading = true;
    this.loading = true;
    const response = await fetch(url, { method: 'GET', headers });
    if (response.ok) {
      const data = await response.json();
      
      // Process each product to ensure it has the expected structure
      this.deliveryItems = (data.data || []).map(product => ({
        ...product,
        // Ensure price is a number
        price: parseFloat(product.price) || 0,
        // Ensure languages array exists with at least a default name
        languages: product.languages || [
          { 
            name: product.name || `Product ${product.id}`,
            langId: 0 
          }
        ],
        // Ensure customizations array exists
        customizations: product.customizations || [],
        // Ensure taxes array exists
        taxes: product.taxes || []
      }));
      
      console.log('Delivery menu items loaded:', this.deliveryItems);
    } else {
      throw new Error('Failed to fetch delivery menu');
    }
  } catch (error) {
    console.error('API Error:', error);
    this.error = error.message;
    this.$toast.error('Failed to load delivery menu');
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
getProductName(product) {
  // Try to get name from languages array if available
  if (product.languages && product.languages.length > 0 && product.languages[0].name) {
    return product.languages[0].name;
  }
  // Fallback to direct name property
  else if (product.name) {
    return product.name;
  }
  // Last resort fallback
  return `Product ${product.id}`;
},
 processBarcodeInput(key) {
  if (key === 'Enter') {
    if(this.barcodeProducts.length>0){
    this.addBarcodeProduct(this.barcodeProducts[0]);
    return;
    }

  }
  
  if (key === 'Backspace') {
    this.barcodeQuery = this.barcodeQuery.slice(0, -1);
  } else if (/^[0-9a-zA-Z]$/.test(key)) {
    this.barcodeQuery += key;
  }
  
  // Trigger search after each keypress
  this.searchByBarcode();
},
   splitTable() {
    if (this.oredrType != 2) {
      return;
    }
    
    console.log('Splitting table...');
  this.$router.push({ name: "SplitTableComponent", params: { orderId: this.orderId} });

  },
// openNumericKeypad(field) {
//   this.currentInput = field;
  
//   // Set the initial value based on which field is being edited
//   let initialValue = '';
//   if (field === 'barcode') {
//     initialValue = this.barcodeQuery;
//   } else if (field === 'firstvalue') {
//     initialValue = this.firstvalue;
//   } else if (field === 'secondvalue') {
//     initialValue = this.secondvalue;
//   } else if (field === 'notes') {
//     initialValue = this.selectedItem.note;
//   } else if (field === 'orderNotes') {
//     initialValue = this.orderNote;
//   } else if (field === 'cancelReason') {
//     initialValue = this.cancelReason;
//   }
  
//   this.$refs.numericKeypad.inputValue = initialValue;
//   this.$refs.numericKeypad.show();
// },
    openNumericKeypad(field) {
    this.currentInput = field;
    
    let initialValue = '';
    if (field === 'barcode') {
      initialValue = this.barcodeQuery;
      // For barcode, use numeric keypad
      this.$refs.numericKeypad.inputValue = initialValue;
      this.$refs.numericKeypad.show();
    } else if (field === 'firstvalue' || field === 'secondvalue') {
      // For discount values, use numeric keypad
      initialValue = field === 'firstvalue' ? this.firstvalue : this.secondvalue;
      this.$refs.numericKeypad.inputValue = initialValue;
      this.$refs.numericKeypad.show();
    } else {
      // For text fields (notes, cancel reason), use full keyboard
      if (field === 'notes') {
        initialValue = this.selectedItem.note;
      } else if (field === 'orderNotes') {
        initialValue = this.orderNote;
      } else if (field === 'cancelReason') {
        initialValue = this.cancelReason;
      }
      
      // Get the actual input element if it exists
      let inputElement = null;
      if (field === 'notes' && document.getElementById('item-notes')) {
        inputElement = document.getElementById('item-notes');
      } else if (field === 'orderNotes' && document.getElementById('order-notes')) {
        inputElement = document.getElementById('order-notes');
      } else if (field === 'cancelReason') {
        // Find the cancel reason textarea
        const textareas = document.querySelectorAll('.reason-input');
        inputElement = textareas[0];
      }
      
      // Set the target input and show the keyboard
      this.$refs.keyboard.setTargetInput(inputElement);
      if (inputElement) {
        inputElement.value = initialValue;
      }
      this.showKeyboard();
    }
  },
  showKeyboard() {
    // Use Bootstrap to show the keyboard modal
    $('#keypad').modal('show');
  },
handleKeypadInput(value) {
  if (this.currentInput === 'barcode') {
    this.barcodeQuery = value;
    this.searchByBarcode();
  } else if (this.currentInput === 'firstvalue') {
    this.firstvalue = value;
    this.validateNumber('firstvalue');
  } else if (this.currentInput === 'secondvalue') {
    this.secondvalue = value;
    this.validateNumber('secondvalue');
  } else if (this.currentInput === 'notes') {
    this.selectedItem.note = value;
  } else if (this.currentInput === 'orderNotes') {
    this.orderNote = value;
  } else if (this.currentInput === 'cancelReason') {
    this.cancelReason = value;
  }
},
   async searchByBarcode() {
  if (!this.barcodeQuery) {
    this.barcodeProducts = [];
    this.showBarcodeResults = false;
    return;
  }
  
  try {
    this.searchQuery = '';
    
    // Fetch barcode segments configuration
    const barcodeSegments = await this.fetchBarcodeSegments();
    if (!barcodeSegments) {
      this.$toast.error('Barcode configuration not found');
      return;
    }
    // Parse barcode according to segments
    const leadChars = parseInt(barcodeSegments.lead_characters) || 0;
    const itemCodeChars = parseInt(barcodeSegments.item_code_characters) || 0;
    const centralLeadChars = parseInt(barcodeSegments.central_lead) || 0;
    const valueChars = parseInt(barcodeSegments.value) || 0;
    
    // Validate barcode length
    const totalLength = leadChars + itemCodeChars + centralLeadChars + valueChars + 
                       (parseInt(barcodeSegments.ending_lead) || 0);
    console.log(totalLength);
    if (this.barcodeQuery.length !== totalLength) {
      this.$toast.error('Invalid barcode length');
      return;
    }
    
    // Extract parts
    let position = 0;
    position += leadChars; // Skip lead characters
    
    const itemCode = this.barcodeQuery.substr(position, itemCodeChars);
    position += itemCodeChars;
    
    position += centralLeadChars; // Skip central lead characters
    
    const value = this.barcodeQuery.substr(position, valueChars);
    position += valueChars;
    
    // Skip ending lead characters (no need to store them)
    
    // Now fetch product by item code
    const token = localStorage.getItem('authToken');
    const productResponse = await axios.get(
      `${BASE_API_URL}/api/products/item-code/${itemCode}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    if (productResponse.data.data) {
      const product = productResponse.data.data;
      const barcodeType = product.barcode_type || 0; 
      console.log(barcodeType);
      let quantity = 1;
      if (barcodeType === 0) {
        console.log(parseInt(value) * parseFloat(product.price));
        this.scantotal = ((parseInt(value) * parseFloat(product.price))/100) - parseFloat(product.price);
      } else {
        quantity = parseFloat(value) / parseFloat(product.price);
        quantity = Math.round(quantity * 100) / 100; 
        product.quantity = quantity;
      }
      if(this.scantotal){
      product.price = this.scantotal;
      this.scantotal = 0
      }
      // Add the product with calculated quantity to results
      this.barcodeProducts = [{
        ...product,
        calculatedQuantity: quantity
      }];
      
      this.showBarcodeResults = true;
    } else {
      this.barcodeProducts = [];
      this.showBarcodeResults = false;
      this.$toast.error('Product not found for this barcode');
    }
  } catch (error) {
    console.error('Barcode processing error:', error);
    this.$toast.error('Failed to process barcode');
    this.barcodeProducts = [];
    this.showBarcodeResults = false;
  }
},
  
    // closeKeypad() {
    //   this.$refs.numericKeypad.hide();
    // },
       handleKeyboardInput(value) {
    if (this.currentInput === 'notes') {
      this.selectedItem.note = value;
    } else if (this.currentInput === 'orderNotes') {
      this.orderNote = value;
    } else if (this.currentInput === 'cancelReason') {
      this.cancelReason = value;
    }
  },

    handleKeyboardSubmit(value) {
    // This is called when "Enter" is pressed on the keyboard
    this.handleKeyboardInput(value);
    this.closeKeypad();
  },

    // Update your existing closeKeypad method
    closeKeypad() {
    this.$refs.numericKeypad.hide();
    $('#keypad').modal('hide'); // Hide the keyboard modal
    this.currentInput = null;
  },
clearBarcodeSearch() {
  this.barcodeQuery = '';
  this.barcodeProducts = [];
  this.showBarcodeResults = false;
},
  
  addBarcodeProduct(product) {
    this.addToOrder(product);
    // this.scantotal = 0;
    this.clearBarcodeSearch();
  },
  
//   handleKeypadInput(value) {
//   if (this.currentInput === 'barcode') {
//     this.barcodeQuery = value;
//     this.searchByBarcode();
//   } else if (this.currentInput === 'firstvalue') {
//     this.firstvalue = value;
//     this.validateNumber('firstvalue');
//   } else if (this.currentInput === 'secondvalue') {
//     this.secondvalue = value;
//     this.validateNumber('secondvalue');
//   }
// },
  combineTables() {
    if (this.oredrType != 2) {
      return;
    }
           this.$router.push({ name: "MergeTableComponent", params: { orderId: this.orderId, tableId: this.tableId} });
    console.log('Combining tables...');
  },
updateCustomizationPrice(customization, event) {
  const isNowSelected = event.target.checked;
  
  // Update in selectedItem
  const mainCustomization = this.selectedItem.customizations.find(
    c => c.id === customization.id
  );
  
  if (mainCustomization) {
    mainCustomization.isSelected = isNowSelected;
    this.selectedItem.price = this.calculateItemPrice(this.selectedItem);
  }
  
  // Update in orderItems
  const orderItemIndex = this.orderItems.findIndex(
    item => item.id === this.selectedItem.id
  );
  
  if (orderItemIndex !== -1) {
    this.orderItems[orderItemIndex] = {
      ...this.selectedItem
    };
  }
},
showCancelDialog() {
      this.cancelReason = ''; // Reset reason
      this.showCancelPopup = true;
    },
   async confirmCancel() {
  if (!this.cancelReason.trim()) {
    alert('Please enter a cancellation reason');
    return;
  }

  try {
    this.$root.isLoading = true;
    const token = localStorage.getItem('authToken');
    const orderId = this.orderId;
    const appId = localStorage.getItem('appId');
    
    await axios.put(
      `${this.$BASE_API_URL}/api/orders/cancel/${orderId}?appId=${appId}`,
      { 
        cancel_reason: this.cancelReason
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    this.showCancelPopup = false;
    this.$toast.success('Order cancelled successfully');
    this.orderItems=[];
    this.oredrType = 0;
    this.tableId = 0;
    // Optionally refresh order data or redirect
  } catch (error) {
    console.error('Order cancellation failed:', error);
    this.$toast.error(error.response?.data?.message || 'Failed to cancel order');
  } finally {
    this.$root.isLoading = false;
  }
},
async printOrder() {
    try {
         console.log('Starting print process...');
    console.log('Order ID:', this.orderId);
    console.log('App ID:', localStorage.getItem('appId'));
    console.log('Branch ID:', localStorage.getItem('branchId'));
    
    if (!this.orderId) {
      this.$toast.error('No order to print');
      return;
    }

    this.$root.isLoading = true;
    
    const token = localStorage.getItem('authToken');
    const appId = localStorage.getItem('appId');
    const branchId = localStorage.getItem('branchId');
    const orderId = this.orderId;

        // First check if order already printed
        try {
            const checkResponse = await axios.get(
                `${BASE_API_URL}/api/print/check-temp/${orderId}`,
                {
                    params: { appId, branchId },
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            );

            if (checkResponse.data.exists) {
                const reprint = confirm('Order already printed. Reprint?');
                if (!reprint) {
                    this.$root.isLoading = false;
                    return;
                }
            }
        } catch (checkError) {
            console.log('Temp check failed, proceeding with print:', checkError);
        }

        // Call the main print endpoint
        const response = await axios.post(
            `${BASE_API_URL}/api/print/order/${orderId}`,
            {
                appId: appId,
                branchId: branchId
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );

        console.log('Print API response:', response.data);

        if (response.data.status) {
            this.$toast.success('Order printed successfully');
            
            // Save to temp table to prevent reprints
            try {
                await axios.post(
                    `${BASE_API_URL}/api/print/save-temp/${orderId}`,
                    { appId, branchId },
                    { headers: { 'Authorization': `Bearer ${token}` } }
                );
            } catch (saveError) {
                console.error('Failed to save to temp table:', saveError);
            }
            
        } else {
            this.$toast.error('Print failed: ' + response.data.message);
        }

    } catch (error) {
        console.error('Full error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        
        this.$toast.error('Print failed: ' + (error.response?.data?.message || error.message));
        
        // Fallback: Generate text file if print fails
        try {
            if (this.orderId) {
                const textContent = this.generateTextFileContent();
                this.downloadTextFile(textContent, `order_${this.orderId}.txt`);
                this.$toast.info('Text file generated as backup');
            }
        } catch (fallbackError) {
            console.error('Fallback also failed:', fallbackError);
        }
        
    } finally {
        this.$root.isLoading = false;
    }
},

    async testPrinters() {
        try {
            const token = localStorage.getItem('authToken');
            const appId = localStorage.getItem('appId');
            const branchId = localStorage.getItem('branchId');

            // Get branch printers
            const response = await axios.get(
                `${BASE_API_URL}/api/print/branch-printers/${branchId}`,
                {
                    params: { appId },
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            );

            const printers = response.data.data;
            
            for (const printer of printers) {
                //const testContent = `TEST PRINT\nPrinter: ${printer.printer_name}\nTime: ${new Date().toLocaleString()}\n\n`;
                
                await axios.post(
                    `${BASE_API_URL}/api/print/test-printer`,
                    {
                        printer_id: printer.cloud_printer_id,
                        ip_address: printer.ip_address,
                        type: printer.cloud_printer_id ? 'cloud' : 'local'
                    },
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                
                this.$toast.success(`Test sent to ${printer.printer_name}`);
            }

        } catch (error) {
            this.$toast.error('Test failed: ' + error.message);
        }
    },
resetPosState() {
  console.log('Resetting POS state...');
  
  // Reset all order-related data
  this.orderItems = [];
  this.orderNote = '';
  this.oredrType = 0;
  this.firstvalue = '';
  this.secondvalue = '';
  this.barcodeQuery = '';
  this.barcodeProducts = [];
  this.showBarcodeResults = false;
  this.orderId = null;
  this.tableId = 0;
  this.table_name = '';
  this.selectedCategoryId = null;
  this.searchQuery = '';
  this.activeTab = 'hotkeys';
  this.ordernet = 0;
  this.selectedOrderTotal = 0;
  this.scantotal = 0;
  this.orderCompleted = false;
  this.showCancelPopup = false;
  this.cancelReason = '';
  
  // Reset selected item
  this.selectedItem = {
    id: null,
    name: '',
    price: 0,
    quantity: 1,
    customizations: [],
    note: ''
  };
  
  // Reset form data
  this.formData = {
    tableNumber: '',
    customerCount: 1,
    reserved_at: new Date().toISOString().slice(0, 16)
  };
  
  // Reset address and customer details
  this.addressDetails = {};
  this.customerInfo = {};
  this.selectedDriverId = null;
  this.selectedFloorId = null;
  
  // Close modals safely - check if they exist and have close methods
  if (this.$refs.customerModal) {
    if (typeof this.$refs.customerModal.close === 'function') {
      this.$refs.customerModal.close();
    } else if (typeof this.$refs.customerModal.hide === 'function') {
      this.$refs.customerModal.hide();
    }
  }
  
  if (this.$refs.takeawayCustomerModal) {
    if (typeof this.$refs.takeawayCustomerModal.close === 'function') {
      this.$refs.takeawayCustomerModal.close();
    } else if (typeof this.$refs.takeawayCustomerModal.hide === 'function') {
      this.$refs.takeawayCustomerModal.hide();
    }
  }
  
  // Hide any open Bootstrap modals safely
  try {
    const customizedishModal = document.getElementById('customizedish');
    if (customizedishModal) {
      $(customizedishModal).modal('hide');
    }
  } catch (e) {
    console.warn('Error hiding customizedish modal:', e);
  }
  
  try {
    const orderNotesModal = document.getElementById('orderNotesModal');
    if (orderNotesModal) {
      $(orderNotesModal).modal('hide');
    }
  } catch (e) {
    console.warn('Error hiding orderNotesModal:', e);
  }
  
  try {
    const keypadModal = document.getElementById('keypad');
    if (keypadModal) {
      $(keypadModal).modal('hide');
    }
  } catch (e) {
    console.warn('Error hiding keypad modal:', e);
  }
  
  // Hide any other modals that might be open
  try {
    $('.modal').modal('hide');
  } catch (e) {
    console.warn('Error hiding modals:', e);
  }
  
  // Focus on barcode input for next order
  this.$nextTick(() => {
    if (this.$refs.barcodeInput) {
      this.$refs.barcodeInput.focus();
    }
  });
  
  console.log('POS state reset successfully');
},
generateTextFileContent() {
  const branchName = localStorage.getItem('branchName') || 'LAMER Branch';
  const userName = localStorage.getItem('userName') || 'pizza';
  const now = new Date();
  const timeString = now.toLocaleTimeString('en-US', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  }).toUpperCase();
  
  let orderType = '';
  switch(this.oredrType) {
    case 1: orderType = 'Delivery'; break;
    case 2: orderType = 'Dine-In'; break;
    case 3: orderType = 'Takeaway'; break;
    default: orderType = 'Dine-In';
  }
  
  // Get customer count or default to 1
  const customerCount = this.formData?.customerCount || 1;
  
  // Create the text content in the exact format you specified
 let content = `        ${branchName}\n\n`;
  content += `        Order :     ${this.orderId}                ${orderType} :${customerCount}\n\n`;
  content += `        Open Time : ${timeString}        By : ${userName} \n\n`;
  content += `Order Details\n\n`;
  content += `    Qty        Item                                                   \n\n`;
  
  // Add order items
  this.orderItems.forEach(item => {
    const qty = item.quantity.toString().padEnd(4);
    const name = item.name.padEnd(50);
    content += `  ${qty}${name}\n`;
  });
  
  content += `-----------------------------------------------------------\n\n`;
  
  // Add totals section
  content += `\n\n\n\n\n\n`;
  content += `        ${branchName}\n\n`;
  content += `        Order :     ${this.orderId}                ${orderType} :${customerCount}\n\n`;
  content += `        Open Time : ${timeString}        By : ${userName} \n\n`;
  content += `\n******************************************\n`;
  content += `       Order's been Updated\n`;
  content += `******************************************\n\n`;
  content += `Order Details\n\n`;
  content += `    Qty        Item                                                   \n\n`;
  
  // Add order items again (as shown in your example)
  this.orderItems.forEach(item => {
    const qty = item.quantity.toString().padEnd(4);
    const name = item.name.padEnd(50);
    content += `  ${qty}${name}\n`;
  });
  
  content += `-----------------------------------------------------------\n\n`;
  content += `\n\n\n`;
  
  return content;
},

// Add this method to download the text file
downloadTextFile(content, filename) {
  // Create a blob with the text content
  const blob = new Blob([content], { type: 'text/plain' });
  
  // Create a download link
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  
  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up the URL object
  URL.revokeObjectURL(link.href);
},

  openNotesModal() {
     if (!this.$hasPermission('update order note')){
        this.$toast.error('Not Permitted');
        return;
    }
    if (!this.checkItemsBeforeAction()) return;
    this.showNotesModal = true;
    this.$nextTick(() => {
      $('#orderNotesModal').modal('show');
    });
  },
  
printTextFile() {
  if (!this.checkItemsBeforeAction()) return;
  
  try {
   const textContent = this.generateTextFileContent({});
    
    // Download the text file
    this.downloadTextFile(textContent, `order_${this.orderId}.txt`);
    
    this.$toast.success('Text file generated successfully');
  } catch (error) {
    console.error('Text file generation error:', error);
    this.$toast.error('Failed to generate text file');
  }
},
  clearOrderNote() {
    this.orderNote = '';
  },
  handlePaymentSuccess() {
    this.$toast.success('Payment processed successfully');
    this.closePayPopup();
    this.orderItems=[];
    this.oredrType = 0;
    this.tableId = 0;
  },
  handlePaymentError(error) {
    this.$toast.error(`Payment failed: ${error}`);
  },
  checkItemsBeforeAction() {
    console.log(this.orderItems.length === 0);
  if (this.orderItems.length === 0) {
    this.toastMessage = 'Please select at least one item before proceeding';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    return false;
  }
  return true;
},
  showCustomerModal() {
  if (!this.$hasPermission('create orders')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.oredrType = 2;
if(this.showmodal != true){
  if (!this.checkItemsBeforeAction()) return;
}
  this.showModal = true;
  this.$nextTick(() => {
    if (this.$refs.customerModal) {
      this.$refs.customerModal.show();
      this.$refs.customerModal.resetForm();
    }
  });
},
closeModal() {
  this.showModal = false;
},
async handleCustomerSubmit(formData) {
  this.formData = formData;
  
  this.selectedFloorId = formData.floorName; 
  
  const isModalTrue = this.$route.params.showmodal === 'true';
  if (!isModalTrue) {
    this.saveOrder();
  }
},
formatPrice(price) {
    return price ? price.toFixed(2) : '0.00'
  },
   validateNumber(field) {
        // Remove non-numeric characters
        this[field] = this[field].replace(/[^0-9]/g, '');
        
        // If current field gets a value, clear the other field
        if (this[field].length > 0) {
            const otherField = field === 'firstvalue' ? 'secondvalue' : 'firstvalue';
            this[otherField] = '';
        }
    },
async saveOrder() {
  try {
    this.$root.isLoading = true;
    this.loading = true;
    
    if (this.orderItems.length === 0) {
      this.toastMessage = 'Please add at least one item to create an order';
      this.showToast = true;
      setTimeout(() => this.showToast = false, 3000);
      return;
    }

    const token = localStorage.getItem('authToken');
    const appId = localStorage.getItem('appId');
    const branchId = localStorage.getItem('branchId');
    const userId = localStorage.getItem('userId');

    // Common order payload
    const orderPayload = {
      type: this.oredrType || 2,
      tax: this.tax,
      totalPay: this.grandTotal,
      grand_total: this.grandTotal,
      note: this.orderNote,
      branchId: branchId || 1,
      appId: appId,
      userId: userId,
      net_total: this.netTotal
    };

    // Add type-specific fields
    if (this.oredrType === 1) {
      orderPayload.area = this.addressDetails.area;
      orderPayload.street = this.addressDetails.street;
      orderPayload.build = this.addressDetails.build;
      orderPayload.floor = this.addressDetails.floor;
      orderPayload.flat = this.addressDetails.flat;
      orderPayload.link = this.addressDetails.link;
      orderPayload.customer = this.addressDetails.customer;
    } else if (this.oredrType === 3) {
      orderPayload.customerName = this.customerInfo?.customerName || '';
      orderPayload.customerPhone = this.customerInfo?.customerPhone || '';
    }

    let orderId = this.orderId;
    let isNewOrder = !orderId;
    let orderResponse;

    console.log('Order type:', this.oredrType);
    console.log('Is new order:', isNewOrder);
    console.log('Order ID:', orderId);

    if (isNewOrder) {
      console.log('Creating new order...');
      
      if (this.oredrType === 2) {
        const tableResponse = await axios({
          method: 'POST',
          url: `${BASE_API_URL}/api/tables?appId=${appId}`,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          data: {
            branchId: branchId,
            waiterId: localStorage.getItem('waiterId'),
            userId: userId,
            name: `${this.formData.tableNumber}`,
            floorId: this.selectedFloorId 
          }
        });

        this.tableId = tableResponse.data.data.id;
        this.table_name = Number(tableResponse.data.data.table_name);
        console.log('Table created:', this.tableId);
      }

      orderResponse = await axios.post(
        `${BASE_API_URL}/api/orders`,
        orderPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!orderResponse.data.status) {
        throw new Error(orderResponse.data.message || 'Failed to create order');
      }

      orderId = orderResponse.data.data.id;
      this.orderId = orderId;
      
      if (!this.oredrType) {
        this.oredrType = 2;
      }
      
      console.log('New order created:', orderId);
      
    } else {
      console.log('Updating existing order:', orderId);
      
      await axios.put(
        `${BASE_API_URL}/api/orders/${orderId}`,
        orderPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
    }

    // ====== ASSIGN ORDER DETAILS ======
    const formattedDate = new Date().toISOString().replace('T', ' ').split('.')[0];
    
    let orderDetailsPayload = {};
    
    if (this.oredrType === 2) {
      orderDetailsPayload = {
        type: 2,
        tableId: this.tableId,
        customersNumber: Number(this.formData.customerCount || 1),
        reserved_at: this.formData.reserved_at || formattedDate,
        waiterId: Number(localStorage.getItem('waiterId')),
        duration_hours: 1,
        floorId: this.selectedFloorId 
      };
    } else if (this.oredrType === 1) {
      orderDetailsPayload = {
        type: 1,
        driverId: this.selectedDriverId,
        area: this.addressDetails.area,
        street: this.addressDetails.street,
        build: this.addressDetails.build,
        floor: this.addressDetails.floor,
        flat: this.addressDetails.flat
      };
    } else if (this.oredrType === 3) {
      orderDetailsPayload = {
        type: 3,
        customerName: this.customerInfo?.customerName,
        customerPhone: this.customerInfo?.customerPhone
      };
    }

    if (Object.keys(orderDetailsPayload).length > 0) {
      try {
        await axios.put(
          `${BASE_API_URL}/api/orders/assign_order_details/${orderId}?appId=${appId}`,
          orderDetailsPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );
        console.log('Order details assigned successfully');
      } catch (detailsError) {
        console.error('Failed to assign order details:', detailsError);
      }
    }

    // ====== ASSIGN PRODUCTS ======
    const productsPayload = {
      products: this.orderItems.map(item => ({
        productId: item.id,
        count: item.quantity,
        price: item.price,
        note: item.note || '',
        customizations: (item.customizations || [])
          .filter(custom => custom.isSelected)
          .map(custom => ({
            id: custom.id,
            option: custom.option || ''
          }))
      }))
    };

    console.log('Products payload:', productsPayload);

    if (!isNewOrder) {
      try {
        await axios.delete(
          `${BASE_API_URL}/api/orders/remove_products/${orderId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            data: {
              product_ids: this.orderItems.map(item => item.id)
            }
          }
        );
        console.log('Old products removed');
      } catch (removeError) {
        if (removeError.response?.data?.message !== 'No matching products found in this order') {
          console.error('Error removing products:', removeError);
        }
      }
    }

    const productsResponse = await axios.post(
      `${BASE_API_URL}/api/orders/assign_products/${orderId}`,
      productsPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!productsResponse.data.status) {
      throw new Error(productsResponse.data.message || 'Failed to assign products');
    }

    console.log('Products assigned successfully');

    // ====== CALL KITCHEN PRINT API AUTOMATICALLY ======
    try {
      console.log('Automatically printing kitchen order for:', orderId);
      
      const printResponse = await axios.post(
        `${BASE_API_URL}/api/orders/${orderId}/kitchenprint`,
        {
          appId: appId,
          printfront: 1,
          vatincluded: 0,
          isReversed: 0
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (printResponse.data.status) {
        console.log('Kitchen print triggered successfully:', printResponse.data);
        this.$toast?.success('Kitchen order sent to printer');
      } else {
        console.warn('Kitchen print failed:', printResponse.data.message);
        this.$toast?.warning('Order saved but kitchen print failed');
      }
    } catch (printError) {
      console.error('Kitchen print error (order still saved):', printError);
      this.$toast?.warning('Order saved but kitchen print failed: ' + (printError.response?.data?.message || printError.message));
    }

    // ====== RESET ORDER STATE AFTER SUCCESSFUL SAVE ======
    const orderTypeNames = {
      1: 'Delivery',
      2: 'Dine-in',
      3: 'Takeaway'
    };
    
    this.toastMessage = isNewOrder 
      ? `${orderTypeNames[this.oredrType] || 'Order'} created successfully!` 
      : 'Order updated successfully!';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // Generate text file backup
    if (orderId) {
      try {
        const textContent = this.generateTextFileContent();
        this.downloadTextFile(textContent, `order_${orderId}.txt`);
        console.log('Text file generated for order:', orderId);
      } catch (fileError) {
        console.error('Error generating text file:', fileError);
      }
    }

    // ====== COMPLETE STATE RESET ======
    this.resetPosState();

    // Handle waiter logout if applicable
    const isModalTrue = this.$route.params.showmodal === 'true';
    if (isModalTrue && localStorage.getItem('waiterToken')) {
      this.$router.push('/loginwaiter');
      localStorage.removeItem('waiterToken');
      localStorage.removeItem('waiterId');
      localStorage.removeItem('isWaiterSuspended');
      localStorage.removeItem('WaiterBranchId');
    }

    this.closeModal();
    this.closePopup();
    this.closePayPopup();

  } catch (error) {
    console.error('Order operation failed:', error);
    
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
    }
    
    this.toastMessage = error.response?.data?.message || 
      error.response?.data?.error || 
      (this.orderId ? 'Failed to update order' : 'Failed to create order');
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // ====== CRITICAL: RESET POS STATE EVEN ON ERROR ======
    // This ensures the sidebar returns to initial state even if order fails
    if (!this.orderId || error.response?.status === 400 || error.response?.status === 403) {
      // Only reset if it's a new order attempt that failed
      this.resetPosState();
    }
    
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},

// async takeawayOrder() {
//   if (!this.$hasPermission('create orders')){
//         this.$toast.error('Not Permitted');
//         return;
//     }
//   try {
//     this.$root.isLoading = true; 
//     this.loading = true;
//     if (this.orderItems.length === 0) {
//       this.toastMessage = 'Please add at least one item to create an order';
//       this.showToast = true;
//       setTimeout(() => this.showToast = false, 3000);
//       return;
//     }

//     // First create the basic order
//     const orderPayload = {
//       type: 3,
//       uesrId: localStorage.getItem("userId"),
//       totalPay: this.grandTotal,
//       branchId: localStorage.getItem('branchId') || 1,
//       note: this.orderNote,
//       grand_total: this.grandTotal,
//       net_total: this.netTotal
//     };

//     const token = localStorage.getItem('authToken');
    
//     // Step 1: Create the base order
//     const orderResponse = await axios.post(
//       `${BASE_API_URL}/api/orders`, 
//       orderPayload,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         }
//       }
//     );

//     if (!orderResponse.data.status) {
//       throw new Error(orderResponse.data.message || 'Failed to create order');
//     }

//     const orderId = orderResponse.data.data.id;

//     // Step 2: Assign products to the order
//     const productsPayload = {
//       products: this.orderItems.map(item => ({
//         productId: item.id,
//         count: item.quantity, 
//         price: item.price,
//         note: item.note || '',
//         customizations: item.customizations.map(custom => ({
//           id: custom.id,
//           option: custom.option
//         }))
//       }))
//     };

//     await axios.post(
//       `${BASE_API_URL}/api/orders/assign_products/${orderId}`, 
//       productsPayload,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         }
//       }
//     );

//     // Handle successful order creation
//     this.toastMessage = 'Order created successfully!';
//     this.showToast = true;
//     setTimeout(() => this.showToast = false, 3000);
    
//     // Reset the order items
//     this.orderItems = [];
    
//     // Close the modal
//     this.closeModal();

//   } catch (error) {
//     console.error('Order creation failed:', error);
//     this.toastMessage = error.response?.data?.message || 'Failed to create order';
//     this.showToast = true;
//     setTimeout(() => this.showToast = false, 30000000000000);
//   }
//   finally {
//       this.$root.isLoading = false;
//       this.loading = false;
//     }
// },
takeawayOrder() {
  if (!this.$hasPermission('create orders')) {
    this.$toast.error('Not Permitted');
    return;
  }
  
  if (this.orderItems.length === 0) {
    this.toastMessage = 'Please add at least one item to create an order';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    return;
  }

  // Show customer information popup
  this.$nextTick(() => {
    if (this.$refs.takeawayCustomerModal) {
      this.$refs.takeawayCustomerModal.show();
    }
  });
},

async handleTakeawayCustomerSubmit(customerInfo) {
  try {
    this.$root.isLoading = true;
    this.loading = true;

    // Create the order payload with customer information
    const orderPayload = {
      type: 3,
      userId: localStorage.getItem("userId"),
      totalPay: this.grandTotal,
      branchId: localStorage.getItem('branchId') || 1,
      note: this.orderNote,
      grand_total: this.grandTotal,
      net_total: this.netTotal,
      customerName: customerInfo.customerName,
      customerPhone: customerInfo.customerPhone || '' 
    };

    const token = localStorage.getItem('authToken');
    
    // Step 1: Create the base order
    const orderResponse = await axios.post(
      `${BASE_API_URL}/api/orders`, 
      orderPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!orderResponse.data.status) {
      throw new Error(orderResponse.data.message || 'Failed to create order');
    }

    const orderId = orderResponse.data.data.id;

    // Step 2: Assign products to the order
    const productsPayload = {
      products: this.orderItems.map(item => ({
        productId: item.id,
        count: item.quantity, 
        price: item.price,
        note: item.note || '',
        customizations: (item.customizations || [])
          .filter(custom => custom.isSelected)
          .map(custom => ({
            id: custom.id,
            option: custom.option || ''
          }))
      }))
    };

    await axios.post(
      `${BASE_API_URL}/api/orders/assign_products/${orderId}`, 
      productsPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    // ====== RESET ORDER STATE AFTER SUCCESSFUL CREATION ======
    this.toastMessage = 'Takeaway order created successfully!';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // Generate text file backup
    try {
      const textContent = this.generateTextFileContent();
      this.downloadTextFile(textContent, `order_${orderId}.txt`);
      console.log('Text file generated for takeaway order:', orderId);
    } catch (fileError) {
      console.error('Error generating text file:', fileError);
    }
    
    // Reset all order state
    this.resetPosState();

  } catch (error) {
    console.error('Takeaway order creation failed:', error);
    this.toastMessage = error.response?.data?.message || 'Failed to create takeaway order';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // ====== RESET POS STATE ON ERROR ======
    // This ensures the sidebar returns to initial state even if order fails
    this.resetPosState();
    
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
// async handleTakeawayCustomerSubmit(customerInfo) {
//   try {
//     this.$root.isLoading = true;
//     this.loading = true;

//     // Create the order payload with customer information
//     const orderPayload = {
//       type: 3,
//       userId: localStorage.getItem("userId"),
//       totalPay: this.grandTotal,
//       branchId: localStorage.getItem('branchId') || 1,
//       note: this.orderNote,
//       grand_total: this.grandTotal,
//       net_total: this.netTotal,
//       customerName: customerInfo.customerName,
//       customerPhone: customerInfo.customerPhone || '' 
//     };

//     const token = localStorage.getItem('authToken');
    
//     // Step 1: Create the base order
//     const orderResponse = await axios.post(
//       `${BASE_API_URL}/api/orders`, 
//       orderPayload,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         }
//       }
//     );

//     if (!orderResponse.data.status) {
//       throw new Error(orderResponse.data.message || 'Failed to create order');
//     }

//     const orderId = orderResponse.data.data.id;

//     // Step 2: Assign products to the order
//     const productsPayload = {
//       products: this.orderItems.map(item => ({
//         productId: item.id,
//         count: item.quantity, 
//         price: item.price,
//         note: item.note || '',
//         customizations: item.customizations.map(custom => ({
//           id: custom.id,
//           option: custom.option
//         }))
//       }))
//     };

//     await axios.post(
//       `${BASE_API_URL}/api/orders/assign_products/${orderId}`, 
//       productsPayload,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         }
//       }
//     );

//     // Handle successful order creation
//     this.toastMessage = 'Takeaway order created successfully!';
//     this.showToast = true;
//     setTimeout(() => this.showToast = false, 3000);
    
//     // Reset the order items and notes
//     this.orderItems = [];
//     this.orderNote = '';

//   } catch (error) {
//     console.error('Takeaway order creation failed:', error);
//     this.toastMessage = error.response?.data?.message || 'Failed to create takeaway order';
//     this.showToast = true;
//     setTimeout(() => this.showToast = false, 3000);
//   } finally {
//     this.$root.isLoading = false;
//     this.loading = false;
//   }
// }, 
openPopup() {
    if (!this.$hasPermission('create orders')){
        this.$toast.error('Not Permitted');
        return;
    }
    if (!this.checkItemsBeforeAction()) return;
      if(this.oredrType == 1){
        this.showdriversPopup = true;
      }else{
        this.showPopup = true;
      }
    },
    addNote(){
      if (!this.checkItemsBeforeAction()) return;

    },
    openPayPopup() {
    if (!this.orderId) return;
      if (!this.$hasPermission('pay order')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.showpayPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.showdriversPopup = false;

    },
    closePayPopup() {
    this.showpayPopup = false;
  },
    async handleAssignDriver(driverID) {
  try {
    this.$root.isLoading = true; 
    this.loading = true;
    const token = localStorage.getItem('authToken');
    const orderId = this.$route.params.orderId;

    if (!orderId) {
      throw new Error('Order ID not found');
    }

    const assignDriverPayload = {
      type: 1, 
      driverId: driverID,
      area: this.addressDetails.area,
      street: this.addressDetails.street,
      build: this.addressDetails.build,
      floor: this.addressDetails.floor,
      flat: this.addressDetails.flat
    };

    const response = await axios.put(
      `${BASE_API_URL}/api/orders/assign_order_details/${orderId}?appId=${localStorage.getItem('appId')}`,
      assignDriverPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!response.data.status) {
      throw new Error(response.data.message || 'Failed to assign driver');
    }

    this.toastMessage = 'Driver assigned successfully!';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);

  } catch (error) {
    console.error('Driver assignment failed:', error);
    this.toastMessage = error.response?.data?.message || 'Failed to assign driver';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},

async handleDeliverySubmit(deliveryData) {
  if (!deliveryData.csutomer) {
    return;
  }
  
  try {
    this.$root.isLoading = true; 
    this.loading = true;
    
    if (this.orderItems.length === 0) {
      this.toastMessage = 'Please add at least one item to create an order';
      this.showToast = true;
      setTimeout(() => this.showToast = false, 3000);
      return;
    }
    
    console.log(deliveryData);
    const orderPayload = {
      type: 1,
      area: deliveryData.area,
      street: deliveryData.street,
      build: deliveryData.build,
      floor: deliveryData.floor,
      flat: deliveryData.flat,
      link: deliveryData.link,
      customer: deliveryData.csutomer,
      note: this.orderNote,
      totalPay: this.grandTotal,
      total: this.grandTotal,
      tax: this.tax,
      grand_total: this.grandTotal,
      branchId: localStorage.getItem('branchId') || 1,
      net_total: this.netTotal
    };

    console.log('Order payload being sent:', orderPayload);
    const token = localStorage.getItem('authToken');

    const orderResponse = await axios.post(
      `${BASE_API_URL}/api/orders`, 
      orderPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!orderResponse.data.status) {
      throw new Error(orderResponse.data.message || 'Failed to create delivery order');
    }

    const orderId = orderResponse.data.data.id;

    const productsPayload = {
      products: this.orderItems.map(item => ({
        productId: item.id,
        count: item.quantity,
        grand_total: this.grandTotal,
        price: item.price,
        note: item.note || '',
        customizations: (item.customizations || [])
          .filter(custom => custom.isSelected)
          .map(custom => ({
            id: custom.id,
            option: custom.option || ''
          }))
      }))
    };

    await axios.post(
      `${BASE_API_URL}/api/orders/assign_products/${orderId}`, 
      productsPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    // ====== RESET ORDER STATE AFTER SUCCESSFUL CREATION ======
    this.toastMessage = 'Delivery order created successfully!';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // Generate text file backup
    try {
      const textContent = this.generateTextFileContent();
      this.downloadTextFile(textContent, `order_${orderId}.txt`);
      console.log('Text file generated for delivery order:', orderId);
    } catch (fileError) {
      console.error('Error generating text file:', fileError);
    }
    
    // Reset all order state
    this.resetPosState();
    
    // Close the delivery popup
    this.closePopup();

  } catch (error) {
    console.error('Delivery order creation failed:', error);
    this.toastMessage = error.response?.data?.message || 'Failed to create delivery order';
    this.showToast = true;
    setTimeout(() => this.showToast = false, 3000);
    
    // ====== RESET POS STATE ON ERROR ======
    // This ensures the sidebar returns to initial state even if order fails
    this.resetPosState();
    
    // Close the delivery popup on error as well
    this.closePopup();
    
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
  async handleLogout() {
      try {
        this.$root.isLoading = true; 
          this.loading = true;
        const token = localStorage.getItem('authToken');
                await axios.post(
          `${this.$BASE_API_URL}/api/auth/logout`, 
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        this.$router.push('/login');
        
      } catch (error) {
        console.error("Logout failed:", error);
        
        // Force logout even if API fails
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        this.$router.push('/login');
      }
      finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
    },
    async fetchProductsByCategory(categoryId) {
  const url = `${BASE_API_URL}/api/products?catId=${categoryId}`;
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };

  try {
    this.$root.isLoading = true; 
          this.loading = true;
    const response = await fetch(url, { method: 'GET', headers });
    if (response.ok) {
      const data = await response.json();
      this.categoryProducts = data.data;
      this.selectedCategoryId = categoryId;
    } else {
      throw new Error('Failed to fetch category products');
    }
  } catch (error) {
    console.error('API Error:', error);
    this.error = error.message;
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},
  
  handleCategoryClick(category) {
    this.fetchProductsByCategory(category.id);
  },
  
  // Modify setActiveTab to reset selected category when switching tabs
  setActiveTab(tab) {
  this.activeTab = tab;
  if (tab !== 'categories') {
    this.selectedCategoryId = null;
  }
  
  // Fetch delivery items when delivery tab is selected
  if (tab === 'delivery' && this.deliveryItems.length === 0) {
    this.fetchDeliveryMenu();
  }
},
  async fetchHotkeys() {
     if (!this.$hasPermission('view hotkeys')){
        this.$toast.error('Not Permitted to view hot keys');
        return;
    }
    const url = `${BASE_API_URL}/api/products/hotkeys`;
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };

    try {
      this.$root.isLoading = true; 
          this.loading = true;
      const response = await fetch(url, { method: 'GET', headers });
      if (response.ok) {
        const data = await response.json();
        this.hotkeys = data.data;
      } else {
        throw new Error('Failed to fetch hotkeys');
      }
    } catch (error) {
      console.error('API Error:', error);
      this.error = error.message;
    }
    finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
  },
  async fetchCategories() {
    const url = `${BASE_API_URL}/api/categories`;
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };

    try {
      this.$root.isLoading = true; 
          this.loading = true;
      const response = await fetch(url, { method: 'GET', headers });
      if (response.ok) {
        const data = await response.json();
        this.categories = data.data;
      } else {
        throw new Error('Failed to fetch categories');
      }
    } catch (error) {
      console.error('API Error:', error);
      this.error = error.message;
    }
    finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
  },

  toggleLinks() {
    const x = document.getElementById("links");
    if (x.style.display === "flex") {
      x.style.display = "none";
    } else {
      x.style.display = "flex";
    }
  },
  getCategoryName(category) {
    // Find English name (langId 1) or return first available name
    const englishName = category.languages?.find(l => l.langId === 0)?.name;
    return englishName || category.languages?.[0]?.name || 'Category';
  },
  // addToOrder(product) {
  //   // Check if item already exists in order
  //    const existingItem = this.orderItems.find(
  //     orderItem => orderItem.id === product.id
  //   );
    
  //   if (existingItem) {
  //     existingItem.quantity++;
  //   } else {
  //     this.orderItems.push({
  //       id: product.id,
  //       name: product.languages[0].name,
  //       price: parseFloat(product.price),
  //       quantity: 1,
  //       customizations: product.customizations,
  //       note: ''
  //     });
  //   }
  // },
totalTaxPercentage() {
  return this.orderItems.reduce((total, item) => {
    const itemTax = item.taxes?.reduce((sum, tax) => sum + tax.percentage, 0) || 0;
    return total + (itemTax * item.quantity);
  }, 0);
},
addToOrder(product) {
  // Safely get the product name
  let productName = '';
  
  // Try to get name from languages array if it exists
  if (product.languages && product.languages.length > 0 && product.languages[0].name) {
    productName = product.languages[0].name;
  } 
  // Fallback to direct name property
  else if (product.name) {
    productName = product.name;
  }
  // Last resort fallback
  else {
    productName = `Product ${product.id}`;
  }

  const totalTaxPercentage = product.taxes?.reduce((sum, tax) => sum + tax.percentage, 0) || 0;
  
  const existingItem = this.orderItems.find(
    orderItem => orderItem.id === product.id
  );  
  
  if (existingItem) {
    existingItem.quantity++;
  } else {
    // Create a deep copy of the product with fresh customization state
    const newItem = {
      id: product.id,
      name: productName,
      basePrice: parseFloat(product.price) || 0,
      price: (parseFloat(product.price) || 0) * (1 + totalTaxPercentage / 100),
      quantity: 1,
      customizations: (product.customizations || []).map(c => ({
        ...c,
        isSelected: false // Start with customizations unselected
      })),
      note: '',
      taxes: product.taxes || []
    };
    
    // Apply any saved customizations from previous instances
    const savedItem = this.orderItems.find(i => i.id === product.id);
    if (savedItem) {
      newItem.customizations = savedItem.customizations;
      // Recalculate price based on saved customizations
      newItem.price = this.calculateItemPrice(newItem);
    }
    
    this.orderItems.push(newItem);
    console.log(this.orderItems);
  }
  
  if (this.orderId) {
    this.ordernet = 0; // Reset so computed properties use current items
    this.selectedOrderTotal = 0;
  }
},

// Add this helper method
calculateItemPrice(item) {
  let price = item.basePrice;
  
  // Add customization prices
  if (item.customizations) {
    item.customizations.forEach(custom => {
      if (custom.isSelected) {
        price += parseFloat(custom.price) || 0;
      }
    });
  }
  
  // Add taxes
  const totalTaxPercentage = item.taxes?.reduce((sum, tax) => sum + tax.percentage, 0) || 0;
  price = price * (1 + totalTaxPercentage / 100);
  
  return Number(price.toFixed(2));
},
  increaseQuantity(item) {
    item.quantity++;
  },

  decreaseQuantity(item) {
    if (item.quantity > 1) {
      item.quantity--;
    } else {
      // Remove item if quantity reaches 0
      this.removeItem(item);
    }
  },

  removeItem(item) {
    console.log(item);
    const index = this.orderItems.indexOf(item);
    if (index > -1) {
      this.orderItems.splice(index, 1);
    }
  },

customizeItem(item) {
  // Find the actual item in orderItems (not a copy)
  const actualItem = this.orderItems.find(i => i.id === item.id) || {...item};
  
  this.selectedItem = {
    ...actualItem,
    // Ensure basePrice is preserved
    basePrice: actualItem.basePrice || parseFloat(actualItem.price)
  };
  
  this.originalPrice = this.selectedItem.basePrice;
  this.availableCustomizations = (this.selectedItem.customizations || []).map(c => ({
    ...c,
    isSelected: c.isSelected || false
  }));
},
async loadExistingOrder() {
  try {
    this.$root.isLoading = true;
    const token = localStorage.getItem('authToken');
    const appId = localStorage.getItem('appId');
    
    // Fetch order details
    const orderResponse = await axios.get(
      `${BASE_API_URL}/api/orders/${this.orderId}?appId=${appId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    if (orderResponse.data.status && orderResponse.data.data) {
      const orderData = orderResponse.data.data;
      
      // Set order properties
      this.ordernet = orderData.net_total || 0;
      this.selectedOrderTotal = orderData.grand_total || 0;
      this.orderNote = orderData.note || '';
      this.oredrType = orderData.type || 0;
      
      // Load order items/products
      if (orderData.products && orderData.products.length > 0) {
        this.orderItems = orderData.products.map(product => ({
          id: product.id,
          name: product.name || product.languages?.[0]?.name || `Product ${product.id}`,
          basePrice: parseFloat(product.price) || 0,
          price: parseFloat(product.price) || 0,
          quantity: product.pivot?.count || 1,
          customizations: product.customizations || [],
          note: product.pivot?.note || '',
          taxes: product.taxes || []
        }));
      }
      
      // If this is a dine-in order (type 2), load table info
      if (orderData.type === 2 && orderData.table) {
        this.tableId = orderData.table.id;
        this.table_name = orderData.table.name;
        this.formData.tableNumber = orderData.table.name;
        this.formData.customerCount = orderData.customersNumber || 1;
        this.formData.reserved_at = orderData.reserved_at || new Date().toISOString().slice(0, 16);
        this.selectedFloorId = orderData.table.floorId;
      }
      
      // If this is a delivery order (type 1), load address details
      if (orderData.type === 1) {
        this.addressDetails = {
          area: orderData.area || '',
          street: orderData.street || '',
          build: orderData.build || '',
          floor: orderData.floor || '',
          flat: orderData.flat || '',
          link: orderData.link || ''
        };
      }
      
      // If this is a takeaway order (type 3), load customer info
      if (orderData.type === 3) {
        // Store customer info if needed
      }
      
      console.log('Order loaded successfully:', this.orderItems);
      console.log('Order type:', this.oredrType);
    }
  } catch (error) {
    console.error('Failed to load existing order:', error);
    this.$toast.error('Failed to load order details');
  } finally {
    this.$root.isLoading = false;
  }
},
  clearCustomizations() {
  this.selectedItem.customizations.forEach(c => {
    c.isSelected = false;
  });
  this.selectedItem.price = this.calculateItemPrice({
    ...this.selectedItem,
    customizations: this.selectedItem.customizations.map(c => ({
      ...c,
      isSelected: false
    }))
  });
  this.selectedItem.note = '';
},

  saveCustomizations() {
  // Hide the modal
  const modal = document.getElementById('customizedish');
  $(modal).modal('hide');
  
  // Find the item in orderItems and update it
  const index = this.orderItems.findIndex(i => i.id === this.selectedItem.id);
  if (index !== -1) {
    this.orderItems[index] = {
      ...this.orderItems[index],
      note: this.selectedItem.note,
      customizations: [...this.selectedItem.customizations],
      price: this.selectedItem.price
    };
  }
  
  // Reset for next use
  this.selectedItem = {
    id: null,
    name: '',
    price: 0,
    quantity: 1,
    customizations: [],
    note: ''
  };
  this.availableCustomizations = [];
},
handleSearch() {
  // This will trigger the computed properties that filter the lists
  if (this.searchQuery) {
    this.barcodeQuery = ''; // Clear barcode search when using product search
    this.showBarcodeResults = false;
  }
},
clearSearch() {
  this.searchQuery = '';
  // Optionally clear barcode results too
  this.barcodeProducts = [];
  this.showBarcodeResults = false;
},
},
computed: {
isOrderCompleted() {
       return this.orderItems.length === 0 || this.orderCompleted;
  },
   filteredDeliveryItems() {
    if (!this.searchQuery) return this.deliveryItems;
    const query = this.searchQuery.toLowerCase();
    return this.deliveryItems.filter(item => {
      const itemName = this.getProductName(item).toLowerCase();
      return itemName.includes(query);
    });
  },
  selectedCustomizationIds: {
    get() {
      return this.selectedCustomizations.map(c => c.id);
    },
    set(ids) {
      this.selectedCustomizations = this.availableCustomizations
        .filter(c => ids.includes(c.id));
    }
  },
  filteredHotkeys() {
    if (!this.searchQuery) return this.hotkeys;
    const query = this.searchQuery.toLowerCase();
    return this.hotkeys.filter(item => 
      item.languages[0].name.toLowerCase().includes(query)
    );
  },
  filteredCategories() {
      if (!this.searchQuery) return this.categories;
    const query = this.searchQuery.toLowerCase();
    return this.categories.filter(category => 
      this.getCategoryName(category).toLowerCase().includes(query)
    ).reverse();
  },
  filteredCategoryProducts() {
    if (!this.searchQuery) return this.categoryProducts;
    const query = this.searchQuery.toLowerCase();
    return this.categoryProducts.filter(product => 
      product.languages[0].name.toLowerCase().includes(query)
    );
  },
  netTotal() {
    // Convert to numbers and provide fallback for NaN
    const ordernet = Number(this.ordernet) || 0;
    const firstvalue = Number(this.firstvalue) || 0;
    const secondvalue = Number(this.secondvalue) || 0;
    
    if (ordernet > 0 && this.selectedOrderTotal > 0) {
      return ((ordernet - firstvalue) * (1 - (secondvalue / 100)));
    }
    
    return this.orderItems.reduce((total, item) => {
      const basePrice = Number(item.basePrice) || 0;
      return total + (basePrice * item.quantity);
    }, 0);
  },
  
  tax() {
    const ordernet = Number(this.ordernet) || 0;
    const selectedTotal = Number(this.selectedOrderTotal) || 0;
    
    if (ordernet > 0 && selectedTotal > 0) {
      const grandTotal = Number(this.grandTotal) || 0;
      const netTotal = Number(this.netTotal) || 0;
      return grandTotal - netTotal;
    }
    
    return this.orderItems.reduce((total, item) => {
      const basePrice = Number(item.basePrice) || 0;
      const itemTaxPercentage = (item.taxes || []).reduce((sum, tax) => 
        sum + (Number(tax.percentage) || 0), 0);
      return total + (basePrice * (itemTaxPercentage / 100) * item.quantity);
    }, 0);
  },
  
  grandTotal() {
    const selectedTotal = Number(this.selectedOrderTotal) || 0;
    const ordernet = Number(this.ordernet) || 0;
    const firstvalue = Number(this.firstvalue) || 0;
    const secondvalue = Number(this.secondvalue) || 0;
    const netTotal = Number(this.netTotal) || 0;
    const tax = Number(this.tax) || 0;
    
    if (selectedTotal > 0 && ordernet > 0) {
      return (selectedTotal - firstvalue) * (1 - (secondvalue / 100));
    }
    
    const afterFixedDiscount = netTotal - firstvalue;
    const afterPercentageDiscount = afterFixedDiscount * (1 - (secondvalue / 100));
    return afterPercentageDiscount + tax;
  }
  },
  created() {
  window.addEventListener('keydown', this.handleGlobalKeyDown);
},
beforeUnmount() {  
  window.removeEventListener('keydown', this.handleGlobalKeyDown);
},
async mounted() {
  this.barcodeSegments = await this.fetchBarcodeSegments();
  this.$nextTick(() => {
    this.$refs.barcodeInput.focus();
  });
  
  // Check if we're coming from a route with orderId
  this.orderId = this.$route.params.orderId;
  this.tableId = this.$route.params.tableId;
  
  console.log('Order ID from route:', this.orderId);
  console.log('Table ID from route:', this.tableId);
  
  // If we have an orderId, load the order data
  if (this.orderId) {
    await this.loadExistingOrder();
  }
  
  if (this.$route.params.showmodal) {
    this.showmodal = true;
    this.showCustomerModal();
  }
  
  try {
    // Fetch hotkeys and categories
    await Promise.all([this.fetchHotkeys(), this.fetchCategories()]);
    
    // Optionally pre-fetch delivery items in the background
    this.fetchDeliveryMenu();
    
  } catch (error) {
    console.error('API Error:', error);
    this.error = error.message || 'An error occurred while fetching data.';
  } finally {
    this.loading = false;
  }
},
};
</script>




<style>
body {
  font-size: 14px;
}
/* Mobile Responsive Design */
@media (max-width: 768px) {
  /* Main layout adjustments */
  .main_box {
    flex-direction: column !important;
    height: auto !important;
  }

  .left_panel {
    width: 100% !important;
    padding: 10px !important;
  }

  .right_panel {
    width: 100% !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    padding: 10px !important;
    background: #f5f5f5;
  }

  /* Menu section adjustments */
  .menue {
    padding: 10px !important;
  }

  .first_row {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 5px !important;
  }

  .aa, .ab, .ac {
    flex: 1 1 auto !important;
    min-width: 100px !important;
    font-size: 12px !important;
    padding: 8px 5px !important;
    text-align: center !important;
  }

  .ac {
    width: auto !important;
  }

  /* Third row items (products grid) */
  .third_row {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)) !important;
    gap: 5px !important;
    padding: 5px !important;
  }

  .item {
    width: 100% !important;
    height: 100px !important;
    margin: 0 !important;
  }

  .itemmenue {
    padding: 5px !important;
  }

  .text3 {
    font-size: 12px !important;
  }

  /* Search and barcode containers */
  .search-bar-container {
    margin-bottom: 10px !important;
  }

  .search-input {
    font-size: 14px !important;
    padding: 8px !important;
  }

  .barcode-search-container {
    width: 100% !important;
    padding-left: 0 !important;
    margin-top: 10px !important;
  }

  .barcode-input {
    font-size: 14px !important;
    padding: 8px !important;
  }

  /* Table header adjustments */
  .table_header {
    display: flex !important;
    flex-wrap: nowrap !important;
    background: #333;
    color: white;
    padding: 8px 5px !important;
  }

  .cell {
    font-size: 11px !important;
    padding: 0 3px !important;
  }

  .itemcell {
    flex: 2 !important;
    min-width: 100px !important;
  }

  .ratecell, .qtycell, .totalcell {
    flex: 1 !important;
    min-width: 60px !important;
  }

  /* Table rows */
  .table_row {
    display: flex !important;
    flex-wrap: nowrap !important;
    padding: 8px 5px !important;
    border-bottom: 1px solid #eee;
  }

  .qtycell {
    display: flex !important;
    align-items: center !important;
    gap: 2px !important;
  }

  .plus, .minus {
    width: 20px !important;
    height: 20px !important;
  }

  .qtycontent {
    font-size: 12px !important;
    min-width: 20px !important;
    text-align: center !important;
  }

  .total {
    font-size: 12px !important;
  }

  .customize svg {
    width: 18px !important;
  }

  /* Table footer */
  .table_footer {
    flex-direction: column !important;
    padding: 10px !important;
  }

  .table_footer > div {
    width: 100% !important;
    margin: 5px 0 !important;
  }

  .leftborder {
    display: none !important;
  }

  /* Discount section */
  .d-flex.flex-column.flex-lg-row.p-2.align-items-center {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .d-flex.flex-row {
    flex-wrap: wrap !important;
    gap: 5px !important;
  }

  .d-flex.flex-row .d-flex {
    width: calc(50% - 5px) !important;
  }

  input#first, input#second {
    width: 100% !important;
    font-size: 12px !important;
    padding: 6px !important;
  }

  /* Order type indicators */
  .takeaway-cards, .delivery-cards {
    width: 100% !important;
    margin: 5px 0 !important;
  }

  .tables {
    width: 100% !important;
    justify-content: center !important;
  }

  .table-cards {
    width: calc(50% - 10px) !important;
    margin: 5px !important;
  }

  /* Right panel buttons */
  .right_panel .right {
    width: 70px !important;
    height: 70px !important;
    margin: 3px !important;
  }

  .right_panel .right svg {
    width: 30px !important;
    height: 30px !important;
  }

  .right_panel .right img {
    width: 30px !important;
    height: 30px !important;
  }

  .right_panel .txt {
    font-size: 9px !important;
    margin-top: 2px !important;
  }

  /* Modal adjustments */
  .modal-dialog {
    margin: 10px !important;
    max-width: calc(100% - 20px) !important;
  }

  .modal-content {
    padding: 15px !important;
  }

  .modal-body1 {
    padding: 10px !important;
  }

  .customization-options {
    max-height: 200px !important;
    overflow-y: auto !important;
  }

  .customization-option {
    margin-bottom: 8px !important;
  }

  .form-check-label {
    font-size: 12px !important;
  }

  .notes-section textarea {
    font-size: 12px !important;
    min-height: 60px !important;
  }

  .buttonsrow {
    margin-top: 10px !important;
  }

  .clear, .cancle, .done {
    padding: 8px 12px !important;
    font-size: 12px !important;
  }

  /* Toast message */
  .toast {
    position: fixed !important;
    bottom: 20px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 90% !important;
    max-width: 300px !important;
    background: #333;
    color: white;
    padding: 12px !important;
    border-radius: 8px !important;
    text-align: center !important;
    z-index: 9999 !important;
  }

  /* Barcode results */
  .barcode-results {
    width: calc(100% - 40px) !important;
    max-height: 150px !important;
    font-size: 12px !important;
  }

  .barcode-result-item {
    padding: 8px !important;
  }

  /* Cancel popup */
  .modal-overlay .modal-dialog {
    width: 95% !important;
    margin: 10px auto !important;
  }

  .reason-input {
    min-height: 80px !important;
    font-size: 12px !important;
  }

  .modal-footer {
    flex-direction: column !important;
    gap: 5px !important;
  }

  .modal-footer .btn {
    width: 100% !important;
    margin: 2px 0 !important;
  }
}

/* Extra small devices (phones, 480px and down) */
@media (max-width: 480px) {
  .third_row {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)) !important;
  }

  .item {
    height: 80px !important;
  }

  .right_panel .right {
    width: 60px !important;
    height: 60px !important;
  }

  .right_panel .right svg,
  .right_panel .right img {
    width: 25px !important;
    height: 25px !important;
  }

  .right_panel .txt {
    font-size: 8px !important;
  }

  .table_header .cell {
    font-size: 10px !important;
  }

  .table_row .cell {
    font-size: 10px !important;
  }

  .qtycell {
    gap: 1px !important;
  }

  .plus svg, .minus svg {
    width: 18px !important;
    height: 18px !important;
  }

  .qtycontent {
    font-size: 11px !important;
    min-width: 16px !important;
  }

  .customize svg {
    width: 16px !important;
  }

  .table_footer {
    padding: 8px !important;
  }

  .table_footer > div {
    font-size: 11px !important;
  }

  input#first, input#second {
    font-size: 11px !important;
    padding: 5px !important;
  }
}

/* Landscape mode */
@media (max-width: 900px) and (orientation: landscape) {
  .main_box {
    flex-direction: row !important;
  }

  .left_panel {
    width: 60% !important;
  }

  .right_panel {
    width: 40% !important;
    flex-direction: column !important;
  }

  .third_row {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)) !important;
  }

  .right_panel .right {
    width: 50px !important;
    height: 50px !important;
  }
}

/* Ensure text doesn't overflow */
.cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.itemcell .note-text {
  white-space: normal !important;
  word-wrap: break-word !important;
}

/* Improve touch targets for mobile */
.plus, .minus, .customize, .clear, .cancle, .done {
  min-width: 44px !important;
  min-height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Fix modal scrolling on mobile */
.modal {
  overflow-y: auto !important;
}

.modal-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
}

/* Improve form inputs on mobile */
input, textarea, select, button {
  font-size: 16px !important; /* Prevents zoom on iOS */
}

/* Ensure the main container doesn't overflow */
.pos {
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

/* Fix for sticky elements on mobile */
.table_header {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
}
.right8{
  background: #cfd186;
}
@media (max-width: 600px) {
  .main_box {
    flex-direction: column; 
  }

  .left_panel, .right_panel {
    width: 100% !important; /* Full width */
    padding: 10px !important;
  }

  .content_table {
    overflow-x: auto; 
  }
.input-group {
  display: flex;
  align-items: stretch;
}

.input-group .form-control {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason-input {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
}

/* Ensure textareas are properly styled when readonly */
.form-control[readonly] {
  background-color: #fff;
  cursor: pointer;
}

.form-control[readonly]:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
  .table_header, .table_row {
    flex-wrap: wrap; /* Allow items to wrap */
  }

  .itemcell, .ratecell, .qtycell, .totalcell {
    flex: 1 1 100px; /* Flexible columns */
    min-width: 80px; /* Minimum column width */
    font-size: 12px !important; /* Smaller font */
  }

  .right_panel .right {
    width: 80px !important; /* Smaller buttons */
    height: 80px !important;
    margin: 5px !important;
  }

  .right_panel .txt {
    font-size: 10px !important; /* Smaller button text */
  }

  /* Modal adjustments */
  .modal-content {
    width: 95% !important;
    margin: 10px auto !important;
  }
}

/* Adjust for height constraints (800px or less) */
@media (max-height: 800px) {
  .main_box {
    height: auto !important;
    min-height: 100vh;
  }

  /* .content_table {
    max-height: 400px; 
    overflow-y: auto; 
  } */
.driver-img{
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg);
}
  .right_panel {
    justify-content: flex-start !important;
    /* overflow-y: auto; */
  }
}
  .green {
    background-color: #4CAF50; 
  }
  .red {
    background-color: #F44336; 
  }
  .search-bar-container {
  position: relative;
  padding-right: 10px;
}

.search-input {
  width: 100%;
  padding: 8px 15px;
  border: 1px solid;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  color: #000;
}
.barcode-search-container {
     height: fit-content;
     padding-left: 22px;
     width: 55%;
}

.barcode-input {
  flex: 1;
    padding: 8px 15px;
    border: 1px solid;
    border-radius: 20px;
    font-size: 14px;
    outline: none;
    width: -webkit-fill-available;
    color: #000;
}

.clear-barcode-btn {
  background: none;
  border: none;
  font-size: 20px;
  margin-left: 8px;
  cursor: pointer;
  color: #777;
}

.barcode-results {
  position: absolute;
  z-index: 1000;
  background: var(--bg-color);
  width: calc(70% - 20px);
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.barcode-result-item {
  padding: 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.barcode-result-item:hover {
  background-color: #2b2b2b;
}
.clear-search-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
}
.right10{
background-color: rgb(255 18 0 / 50%);
}
.clear-search-btn:hover {
  color: #333;
}
.white{
  color: #fff;
}
.aa.active, .ab.active {
  color: white;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}

.modal-content {
  padding: 20px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-header h5 {
  margin: 0;
  font-size: 1.25rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.reason-input {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-danger {
  background: #dc3545;
  color: white;
}
.aa, .ab, .ac {
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.aa.active, .ab.active, .ac.active {
  background-color: #E3655B;
  color: white;
  border-radius: 5px;
}
.ac {
  height: 35px;
  width: 159px;
  text-align-last: center;
  border-radius: 5px;
  background-color: #E3655B;
}
</style>